<template>
  <div
    class="chats service-detail"
    style="height: 100%"
  >
    <b-tabs
      v-model="activeTabState"
      content-class="mt-0"
      style="height: 100%; display: flex; flex-direction: column"
    >
      <b-tab
        :title="$t('general.detail')"
        :active="activeTabState === 0"
        style="overflow: auto"
      >
        <div
          class="tree-node accordion"
          role="tablist"
        >
          <b-card
            no-body
            class="mb-0"
            style="background-color: transparent"
          >
            <div
              header-tag="header"
              variant="info"
            >
              <div
                class="personal-info pt-0"
                style="width: 100%"
              >
                <div class="list-unstyled">
                  <div style="display: flex; flex-direction: column; gap: 1em">
                    <p class="detail-title">
                      {{ $t('general.basic_information') }}
                    </p>
                    <div class="chat-agent-detail detail-group-tab">
                      <div class="detail-group">
                        <label>{{ $t('permission.project') }}</label>
                        <p class="mb-0">
                          {{ getProjectName(activeChannel.projectName) }}
                        </p>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('general.origin') }}</label>
                        <p class="mb-0">
                          {{ getOrigin(activeChannel) }}
                        </p>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('breadcrumb.serviceCategory') }}</label>
                        <p class="mb-0">
                          {{
                            activeChannel.serviceCategory &&
                              activeChannel.serviceCategory.name &&
                              Object.keys(activeChannel.serviceCategory.name)
                                .length
                              ? activeChannel.serviceCategory.name[
                                $i18n.locale
                              ] ||
                                activeChannel.serviceCategory.name['zh'] ||
                                activeChannel.serviceCategory.name['en'] ||
                                activeChannel.serviceCategory.name['km'] ||
                                activeChannel.serviceCategory.name['vi'] ||
                                $t('general.not_available')
                              : $t('general.not_available')
                          }}
                        </p>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('breadcrumb.serviceType') }}</label>
                        <p class="mb-0">
                          {{
                            activeChannel.serviceType &&
                              activeChannel.serviceType.name &&
                              Object.keys(activeChannel.serviceType.name).length
                              ? activeChannel.serviceType.name[$i18n.locale] ||
                                activeChannel.serviceType.name['zh'] ||
                                activeChannel.serviceType.name['en'] ||
                                activeChannel.serviceType.name['km'] ||
                                activeChannel.serviceType.name['vi'] ||
                                $t('general.not_available')
                              : $t('general.not_available')
                          }}
                        </p>
                      </div>

                      <div
                        v-if="(subTypes || []).length > 0"
                        class="detail-group"
                      >
                        <label>{{ $t('breadcrumb.serviceSubType') }}</label>
                        <div
                          class="mb-0"
                          style="display: flex; gap: 4px; flex-wrap: wrap;"
                        >
                          {{ subTypes.join(', ') }}

                          <!-- <b-badge
                            v-for="subType in subTypes"
                            :key="subType"
                            pill
                            style="font-size: 85%;"
                            badge-glow
                            variant="secondary"
                          >
                            {{ subType }}
                          </b-badge> -->
                        </div>
                      </div>
                    </div>

                    <p
                      v-if="
                        activeChannel.meta &&
                          Object.keys(activeChannel.meta).length > 0
                      "
                      class="detail-title"
                    >
                      {{ $t('general.meta_information') }}
                    </p>
                    <div class="chat-agent-detail detail-group-tab">
                      <!-- <div class="detail-group">
                        <label>{{ $t('general.building_type') }}</label>
                        <p class="mb-0">
                          {{
                            (activeChannel.meta &&
                              activeChannel.meta.buildingType) ||
                              $t('general.not_available')
                          }}
                        </p>
                      </div> -->

                      <div
                        v-if="
                          hasBuildingName
                        "
                        class="detail-group"
                      >
                        <label>{{ $t('general.building_name') }}</label>
                        <p class="mb-0">
                          {{
                            getTranslatedBuildingName(activeChannel.meta)
                          }}
                        </p>
                      </div>

                      <div
                        v-if="hasEnterpriseName"
                        class="detail-group"
                      >
                        <label>{{ $t('general.enterprise_name') }}</label>
                        <p class="mb-0">
                          {{
                            getTranslatedEnterpriseName(activeChannel.meta)
                          }}
                        </p>
                      </div>

                      <div
                        v-if="hasRoomName"
                        class="detail-group"
                      >
                        <label>{{ $t('general.room_name') }}</label>
                        <p class="mb-0">
                          {{
                            getTranslatedRoomName(activeChannel.meta)
                          }}
                        </p>
                      </div>
                    </div>

                    <p class="detail-title">
                      {{ $t('general.service_information') }}
                    </p>
                    <div class="chat-agent-detail detail-group-tab">
                      <div class="detail-group">
                        <label>{{ $t('general.service_title') }}</label>
                        <p
                          v-if="
                            activeChannel.name &&
                              Object.keys(activeChannel.name).length
                          "
                          class="mb-0"
                        >
                          {{
                            activeChannel.name[$i18n.locale] ||
                              activeChannel.name['zh'] ||
                              activeChannel.name['en'] ||
                              activeChannel.name['km'] ||
                              activeChannel.name['vi'] ||
                              $t('general.not_available')
                          }}
                        </p>
                        <p
                          v-else
                          class="mb-0"
                        >
                          {{ $t('general.not_available') }}
                        </p>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('general.service_price') }}</label>
                        <p class="mb-0">
                          {{ getPrice() }}
                        </p>
                      </div>

                      <!-- <div
                        v-if="activeChannel.servicePriceInit && activeChannel.servicePriceInit !== 0"
                        class="detail-group"
                      >
                        <label>{{ $t('field.originalPrice') }}</label>
                        <p class="mb-0">
                          {{ getOriginalPrice() }}
                        </p>
                      </div> -->
                      <div class="detail-group">
                        <label>{{ $t('general.meta_data') }}</label>
                        <template v-if="activeChannel.origin === 'external'">
                          <div
                            v-if="activeChannel.isNoChatChannel"
                            class="mb-0"
                            style="border-radius: 0.5rem; width: 100%; overflow: hidden;"
                          >
                            <div
                              v-for="(param, index) in activeChannel.params"
                              :key="param + index"
                            >
                              <b-card
                                class="mb-0"
                                style="border-radius: 0.5rem !important"
                              >
                                <b-row
                                  v-if="param.responseParams"
                                  class="chat-agent-detail"
                                >
                                  <b-col md="12">
                                    <div
                                      class="detail-group"
                                      style="
                                        display: flex;
                                        flex-direction: column;
                                        gap: 1rem;
                                      "
                                    >
                                      <div
                                        v-for="parameter in param.parameters"
                                        :key="parameter.key"
                                      >
                                        <div>
                                          <span
                                            style="
                                              width: 160px;
                                              font-weight: 500;
                                              color: #6e6b7b;
                                              font-size: 0.9rem;
                                              text-transform: capitalize;
                                            "
                                          >
                                            {{ getParamName(parameter) }}:</span>
                                          <div
                                            v-if="
                                              getResponse(
                                                param.responseParams[
                                                  parameter.key
                                                ]
                                              ).type === 'files'
                                            "
                                          >
                                            <div class="file-list mt-1">
                                              <div
                                                v-for="(
                                                  { url, mimeType }, idx
                                                ) in getResponse(
                                                  param.responseParams[
                                                    parameter.key
                                                  ]
                                                ).files"
                                                :key="url + idx"
                                                class="file-item d-flex align-items-center"
                                              >
                                                <div
                                                  class="file-preview cursor-pointer"
                                                  @click="
                                                    showMediaPreview(
                                                      url,
                                                      getResponse(
                                                        param.responseParams[
                                                          parameter.key
                                                        ]
                                                      ).files
                                                    )
                                                  "
                                                >
                                                  <img
                                                    v-if="
                                                      (mimeType || []).includes(
                                                        'image/'
                                                      )
                                                    "
                                                    :src="url"
                                                    alt="preview"
                                                  >
                                                  <div
                                                    v-else-if="
                                                      (mimeType || []).includes(
                                                        'video/'
                                                      )
                                                    "
                                                    :style="{
                                                      padding: '8px 3px',
                                                      position: 'relative'
                                                    }"
                                                  >
                                                    <feather-icon
                                                      icon="VideoIcon"
                                                      size="20"
                                                    />
                                                  </div>
                                                  <div
                                                    v-else-if="
                                                      (mimeType || []).includes(
                                                        'audio/'
                                                      )
                                                    "
                                                    :style="{
                                                      padding: '8px 3px',
                                                      position: 'relative'
                                                    }"
                                                  >
                                                    <feather-icon
                                                      icon="MicIcon"
                                                      size="20"
                                                    />
                                                  </div>
                                                  <div
                                                    v-else
                                                    :style="{
                                                      padding: '8px 3px',
                                                      position: 'relative'
                                                    }"
                                                  >
                                                    <file-icon
                                                      :style="{ color: 'gray' }"
                                                    />
                                                    <span
                                                      class="file-ext"
                                                      :style="{
                                                        color: 'white'
                                                      }"
                                                    >
                                                      {{
                                                        getFileExtDisplay(url)
                                                      }}
                                                    </span>
                                                  </div>
                                                </div>
                                                <span
                                                  class="ml-2 file-name cursor-pointer text-truncate"
                                                  style="width: 400px"
                                                  @click="
                                                    showMediaPreview(
                                                      url,
                                                      getResponse(
                                                        param.responseParams[
                                                          parameter.key
                                                        ]
                                                      ).files
                                                    )
                                                  "
                                                >
                                                  {{ $t('general.view') }}
                                                </span>
                                              </div>

                                              <div
                                                v-if="
                                                  getResponse(
                                                    param.responseParams[
                                                      parameter.key
                                                    ]
                                                  ).files.length > 5 && !showAll
                                                "
                                                class="show-more-button mt-2 cursor-pointer"
                                                @click="showAll = true"
                                              >
                                                {{
                                                  $t('general.showAllFiles', {
                                                    count:
                                                      getResponse(
                                                        param.responseParams[
                                                          parameter.key
                                                        ]
                                                      ).files.length - 5
                                                  })
                                                }}
                                              </div>
                                            </div>
                                          </div>
                                          <span
                                            v-else-if="
                                              getType(parameter) === 'text'
                                            "
                                            style="
                                              margin-left: 4px;
                                              padding: 1px 5px 1px 1px;
                                            "
                                          >
                                            {{
                                              getResponse(
                                                param.responseParams[
                                                  parameter.key
                                                ]
                                              )
                                            }}
                                            <span
                                              v-if="parameter.key === 'description' || parameter.key === 'note' || parameter.key === 'specialInstructions'"
                                            >
                                              <b-button
                                                  class="btn-translate"
                                                  v-b-tooltip.hover
                                                  :title="!paramLoading[parameter.key]
                                                    ? (paramTranslated[parameter.key] ? $t('chat.revert') : $t('chat.translate'))
                                                    : ''"
                                                  variant="light"
                                                  pill
                                                  style="
                                                    height: fit-content;
                                                    width: fit-content;
                                                    padding: 4px 8px;
                                                    margin-right: 0.5rem;
                                                    margin-left: 4px;
                                                  "
                                                  size="sm"
                                                  @click="paramTranslated[parameter.key]
                                                    ? revertParam(parameter.key, param)
                                                    : translateParam(parameter.key, getResponse(param.responseParams[parameter.key]), param)"
                                                >
                                                  <b-spinner v-if="paramLoading[parameter.key]" style="width: 14px; height: 14px;" label="loading"></b-spinner>
                                                  <feather-icon v-else-if="paramTranslated[parameter.key]" icon="CornerUpLeftIcon" style="width: 14px; height: 14px;" />
                                                  <translate-icon v-else style="width: 13px; height: 13px;" />
                                                </b-button>
                                            </span>
                                            <span
                                              v-else-if="parameter.key === 'orderId'"
                                            >
                                              <b-button
                                                v-b-tooltip.hover
                                                :title="
                                                  $t('button.copy_order_id')
                                                "
                                                variant="light"
                                                pill
                                                style="
                                                  height: fit-content;
                                                  width: fit-content;
                                                  padding: 4px 8px;
                                                  margin-right: 0.5rem;
                                                "
                                                size="sm"
                                                @click="
                                                  copyToClipboard(
                                                    getResponse(
                                                      param.responseParams[
                                                        parameter.key
                                                      ]
                                                    )
                                                  )
                                                "
                                              >
                                                <feather-icon icon="CopyIcon" />
                                              </b-button>
                                            </span>
                                          </span>
                                          <span
                                            v-else-if="
                                              getType(parameter) === 'link'
                                            "
                                          >
                                            <a
                                              :href="
                                                getResponse(
                                                  param.responseParams[
                                                    parameter.key
                                                  ]
                                                )
                                              "
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              class="text-primary"
                                            >
                                              {{
                                                getResponse(
                                                  param.responseParams[
                                                    parameter.key
                                                  ]
                                                )
                                              }}
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-card>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <p
                            v-if="!hasMetaData"
                            class="mb-0"
                          >
                            {{ $t('general.not_available') }}
                          </p>

                          <b-card
                            v-else
                            class="mb-0 meta-data-card meta-group"
                            style="width: 100%"
                          >
                            <div
                              style="
                                display: flex;
                                flex-direction: column;
                                gap: 1rem;
                              "
                            >
                              <div class="detail-group mb-0">
                                <label
                                  style="
                                    width: 160px;
                                    font-weight: 500;
                                    color: #6e6b7b;
                                    font-size: 0.9rem;
                                    text-transform: capitalize;
                                  "
                                >
                                  {{ $t('general.order_id') }}</label>
                                <span>
                                  {{ activeChannel.id }}
                                  <span>
                                    <b-button
                                      v-b-tooltip.hover
                                      :title="$t('button.copy_order_id')"
                                      variant="light"
                                      pill
                                      style="
                                        height: fit-content;
                                        width: fit-content;
                                        padding: 4px 8px;
                                        margin-right: 0.5rem;
                                      "
                                      size="sm"
                                      @click="copyToClipboard(activeChannel.id)"
                                    >
                                      <feather-icon icon="CopyIcon" />
                                    </b-button>
                                  </span>
                                </span>
                              </div>
                              <div
                                v-for="(value, key) in filteredParams"
                                :key="key"
                                v-if="isValidValue(value, key)"
                              >
                                <div
                                  class="detail-group mb-0"
                                >
                                  <label>{{ getLabel(key, value) }}</label>
                                  <p
                                    v-if="key === 'address'"
                                    class="mb-0"
                                  >
                                    {{ getAddressLabel(value) }}
                                  </p>
                                  <p
                                    v-else-if="key.toLowerCase().includes('date')"
                                    class="mb-0"
                                  >
                                    {{ value | formatDate }}
                                  </p>
                                  <div
                                    v-else-if="key === 'files'"
                                    class="mb-0"
                                  >
                                    <div
                                      class="detail-group"
                                      style="
                                        display: flex;
                                        flex-direction: column;
                                        gap: 1rem;
                                      "
                                    >
                                      <div class="file-list mt-1">
                                        <div
                                          v-for="(
                                            { url, mimeType }, idx
                                          ) in value"
                                          :key="url + idx"
                                          class="file-item d-flex align-items-center"
                                        >
                                          <div
                                            class="file-preview cursor-pointer"
                                            @click="
                                              showMediaPreview(url, value)
                                            "
                                          >
                                            <img
                                              v-if="(mimeType || []).includes('image/')"
                                              :src="url"
                                              alt="preview"
                                            >
                                            <div
                                              v-else-if="
                                                (mimeType || []).includes('video/')
                                              "
                                              :style="{
                                                padding: '8px 3px',
                                                position: 'relative'
                                              }"
                                            >
                                              <feather-icon
                                                icon="VideoIcon"
                                                size="20"
                                              />
                                            </div>
                                            <div
                                              v-else-if="
                                                (mimeType || []).includes('audio/')
                                              "
                                              :style="{
                                                padding: '8px 3px',
                                                position: 'relative'
                                              }"
                                            >
                                              <feather-icon
                                                icon="MicIcon"
                                                size="20"
                                              />
                                            </div>
                                            <div
                                              v-else
                                              :style="{
                                                padding: '8px 3px',
                                                position: 'relative'
                                              }"
                                            >
                                              <file-icon
                                                :style="{ color: 'gray' }"
                                              />
                                              <span
                                                class="file-ext"
                                                :style="{ color: 'white' }"
                                              >
                                                {{ getFileExtDisplay(url) }}
                                              </span>
                                            </div>
                                          </div>
                                          <span
                                            class="ml-2 file-name cursor-pointer text-truncate"
                                            style="width: 400px"
                                            @click="
                                              showMediaPreview(url, value)
                                            "
                                          >
                                            {{ $t('general.view') }}
                                          </span>
                                        </div>

                                        <div
                                          v-if="value.length > 5 && !showAll"
                                          class="show-more-button mt-2 cursor-pointer"
                                          @click="showAll = true"
                                        >
                                          {{
                                            $t('general.showAllFiles', {
                                              count: value.length - 5
                                            })
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else-if="key === 'items' && Array.isArray(value)" class="mb-0">
                                    <div
                                      class="detail-group"
                                      style="
                                        display: flex;
                                        flex-direction: column;
                                        gap: 0.5rem;
                                      "
                                    >
                                      <div
                                        v-for="(item, idx) in value"
                                        :key="item.id || item.code || idx"
                                        class="d-flex align-items-center"
                                        style="
                                          padding: 6px 8px;
                                          background: #f8f8f8;
                                          border-radius: 6px;
                                        "
                                      >
                                        <img
                                          v-if="item.photo || isWaterService"
                                          :src="item.photo || '/bottle-of-water.png'"
                                          alt="item"
                                          style="
                                            width: 40px;
                                            height: 40px;
                                            object-fit: cover;
                                            border-radius: 4px;
                                            background: #f0f0f0;
                                            padding: 4px;
                                            flex: 0 0 auto;
                                          "
                                          @error="onItemImageError"
                                        >
                                        <div class="ml-2 d-flex flex-column" style="min-width: 0;">
                                          <span class="text-truncate" style="max-width: 260px; font-weight: 500;">
                                            {{ (item.translations && (item.translations[currentLocale] || item.translations.en))
                                              || (item.name && (item.name[currentLocale] || item.name.en))
                                              || item.name
                                              || '' }}
                                          </span>
                                          <div class="d-flex align-items-center" style="gap: 8px;">
                                            <small style="color: #6e6b7b;">
                                              {{ item.price | currency("$") }}
                                            </small>
                                            <small style="font-weight: 600; color: #6e6b7b;">x{{ item.qty }}</small>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <p
                                    v-else
                                    class="mb-0"
                                  >
                                    {{ (key === 'total' ? '$' : '') + formatValue(key, value) }}
                                  </p>
                                  <span
                                    v-if="key === 'description' || key === 'note' || key === 'specialInstructions'"
                                  >
                                    <b-button
                                        class="btn-translate"
                                        v-b-tooltip.hover
                                        :title="!paramLoading[key]
                                          ? (paramTranslated[key] ? $t('chat.revert') : $t('chat.translate'))
                                          : ''"
                                        variant="light"
                                        pill
                                        style="
                                          height: fit-content;
                                          width: fit-content;
                                          padding: 4px 8px;
                                          margin-right: 0.5rem;
                                          margin-left: 4px;
                                        "
                                        size="sm"
                                        @click="paramTranslated[key]
                                          ? revertParam(key)
                                          : translateParam(key, value)"
                                      >
                                        <b-spinner v-if="paramLoading[key]" style="width: 14px; height: 14px;" label="loading"></b-spinner>
                                        <feather-icon v-else-if="paramTranslated[key]" icon="CornerUpLeftIcon" style="width: 14px; height: 14px;" />
                                        <translate-icon v-else style="width: 13px; height: 13px;" />
                                      </b-button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </template>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('general.initiate_time') }}</label>
                        <p class="mb-0">
                          {{ activeChannel.createdAt | formatDate }}
                        </p>
                      </div>
                    </div>

                    <p class="detail-title">
                      {{ $t('general.handling_by') }}
                    </p>
                    <div class="chat-agent-detail detail-group-tab handling-by">
                      <div
                        class="helper-btn-groups"
                      >
                        <!-- <b-button
                          size="sm"
                          class="btn"
                          style="border: #006BE5 1px solid !important; color: #006BE5 !important"
                          variant="outline-danger"
                          @click="replaceHelper(activeChannel.id)"
                        >
                          {{ $t('button.replace') }}
                        </b-button> -->
                        <b-button
                          size="sm"
                          class="btn"
                          style="border: var(--primary) 1px solid !important; color: var(--primary) !important"
                          variant="outline-danger"
                          @click="openOperatorTrackerModal(activeChannel.assignedOperatorId, activeChannel)"
                        >
                          {{ $t('button.tracking') }}
                        </b-button>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.departmentName') }}</label>
                        <p class="mb-0">
                          {{ getDepartmentName(activeChannel.departmentName, activeChannel.assignedOperator) }}
                        </p>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.operator') }}</label>
                        <div class="d-flex align-items-center">
                          <p
                            v-if="activeChannel.assignedOperator"
                            class="mb-0 mr-1"
                            style="width: 200px"
                          >
                            {{ activeChannel.assignedOperator }}
                          </p>
                          <p
                            v-else
                            class="mb-0 mr-1"
                            style="color: #e83e8c; width: 200px"
                          >
                            {{ $t('ticket.unassigned') }}
                          </p>
                          <!-- <b-button
                            v-if="
                              activeChannel.status !== 'resolved' &&
                                activeChannel.status !== 'cancel'
                            "
                            v-b-tooltip.hover
                            size="sm"
                            variant="flat-primary"
                            :title="
                              !canEditOperator
                                ? $t(
                                  'ticket.change_assignee_ticket_required_access'
                                )
                                : titleComputed
                            "
                            class="p-0"
                            :class="{ 'not-allowed': !canEditOperator }"
                            @click="handleEditStatus"
                          >
                            {{ $t('button.edit') }}
                          </b-button> -->
                        </div>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.status') }}</label>
                        <div class="d-flex align-items-center">
                          <div
                            class="mb-0 mr-1"
                            style="width: 200px"
                          >
                            <ServiceStatus
                              v-if="mainOperatorStatus"
                              :status="mainOperatorStatus"
                            />
                          </div>
                          <!-- <b-button
                            v-if="
                              activeChannel.status !== 'resolved' &&
                                activeChannel.status !== 'cancel'
                            "
                            v-b-tooltip.hover
                            size="sm"
                            variant="flat-primary"
                            :title="
                              !canEditStatus
                                ? $t(
                                  'ticket.update_status_ticket_required_access'
                                )
                                : titleComputed
                            "
                            class="p-0"
                            :class="{ 'not-allowed': !canEditStatus }"
                            @click="handleEditStatus"
                          >
                            {{ $t('button.edit') }}
                          </b-button> -->
                        </div>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.latest_tracking') }}</label>
                        <div
                          v-if="detailTrackingList.length"
                          class="mb-0 tracking-item"
                          style="width: 100%"
                        >
                          <div
                            v-for="(step, index) in detailTrackingList"
                            v-if="step"
                            :key="index"
                            class="step-card position-relative"
                          >
                            <!-- Step Number Badge -->
                            <!-- <div
                              class="step-number"
                              :class="`bg-${step.status}`"
                            >
                              <span>{{ index + 1 }}</span>
                            </div> -->

                            <!-- Vertical Line -->
                            <div v-if="index < detailTrackingList.length - 1" />
                            <b-row>
                              <b-col>
                                <h6 :class="step.status">
                                  {{ $t(`status.${step.status}`) }}
                                </h6>
                                <p
                                  v-if="step.status === 'pending' && step.isAutoAssign"
                                  v-html="getStatusDescription('pendingSystem', step.assignedOperator, getStepAssignOperatorId(step))"
                                />
                                <p
                                  v-else-if="step.status === 'pending' && step.assignedBy"
                                  v-html="getStatusDescription('pendingHuman', getStepAssignedByOperatorName(step), getStepAssignedByOperatorId(step), step.assignedOperator, getStepAssignOperatorId(step))"
                                />
                                <p
                                  v-else-if="step.status === 'pending' && !step.isAutoAssign && !step.assignedBy"
                                  v-html="getStatusDescription('pendingHuman', step.assignedOperator, getStepAssignOperatorId(step), step.assignedOperator, getStepAssignOperatorId(step))"
                                />
                                <p
                                  v-else-if="step.status === 'cancel' && step.participant.participantType === 'cronJob'"
                                  v-html="$t('statusDescription.cancelSystem')"
                                />
                                <p
                                  v-else-if="step.status === 'replaced'"
                                  v-html="getStatusDescription('replaced', step.transfer.fromOperator, step.transfer.fromOperatorId, step.transfer.toOperator, step.transfer.toOperatorId)"
                                />
                                <p
                                  v-else-if="
                                    step.status === 'cancel' &&
                                      step.participant.participantType ===
                                      'customer'
                                  "
                                  v-html="
                                    $t(
                                      'statusDescription.cancelledByCustomer',
                                      {
                                        operator: step.participant.name
                                      }
                                    )
                                  "
                                />
                                <p
                                  v-else-if="
                                    step.status === 'assign' &&
                                      !step.isAutoAssign
                                  "
                                  v-html="
                                    getStatusDescription(
                                      'manualAssign',
                                      step.participant.name,
                                      getStepAssignOperatorId(step)
                                    )
                                  "
                                />
                                <div
                                  v-else-if="step.status === 'pending'"
                                  class="mb-1"
                                  v-html="
                                    getStatusDescription(
                                      'pending',
                                      step.assignedOperator,
                                      getStepAssignOperatorId(step)
                                    )
                                  "
                                />
                                <p
                                  v-else
                                  class="mb-1"
                                  v-html="
                                    getStatusDescription(
                                      step.status,
                                      step.assignedOperator,
                                      getStepAssignOperatorId(step)
                                    )
                                  "
                                />
                                <div class="detail-group">
                                  <label>{{
                                    step.createdAt | formatDate
                                  }}</label>
                                </div>
                                <div v-if="step.isNoPriceSpecialists && step.isFinalCompleted">
                                  <div>
                                    <template>
                                      <template v-if="step.servicePrice !== null">
                                        <strong>
                                          {{ $t('field.servicePrice') }}:
                                        </strong>
                                        {{
                                          !!step.servicePrice || step.servicePrice === 0
                                            ? formatNumber(
                                              step.servicePrice,
                                              step.servicePriceCurrency
                                            ) +
                                              ' ' +
                                              (step.servicePriceCurrency || '')
                                            : $t('general.not_available')
                                        }}
                                        <br>
                                      </template>
                                      <div style="margin-top: 4px;" v-if="!!step.servicePriceInit">
                                        <strong>
                                          {{ $t('field.originalPrice') }}:
                                        </strong>
                                        {{
                                          formatNumber(
                                            step.servicePriceInit
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                        }}
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <div
                                  v-else-if="
                                    step.status === 'completed' ||
                                      step.status === 'cancel' ||
                                      step.status === 'hold'
                                  "
                                >
                                  <div>
                                    <template
                                      v-if="step.status === 'completed' && !step.isFromHelper && !step.isPartialCompleted && step.servicePrice !== null"
                                    >
                                      <strong>
                                        {{ $t('field.servicePrice') }}:
                                      </strong>
                                      {{
                                        !!step.servicePrice || step.servicePrice === 0
                                          ? formatNumber(
                                            step.servicePrice,
                                            step.servicePriceCurrency
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                          : $t('general.not_available')
                                      }}
                                      <br>
                                      <div style="margin-top: 4px;" v-if="!!step.servicePriceInit">
                                        <strong>
                                          {{ $t('field.originalPrice') }}:
                                        </strong>
                                        {{
                                          formatNumber(
                                            step.servicePriceInit
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                        }}
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <div
                                  v-if="
                                    (step.status === 'completed' ||
                                      step.status === 'cancel' ||
                                      step.status === 'hold') &&
                                      step.remark
                                  "
                                  class="mt-1"
                                >
                                  <div>
                                    <strong> {{ $t('field.remark') }}: </strong>
                                    <span>{{ step.remark || $t('general.not_available') }}</span>
                                    <b-button
                                      class="btn-translate"
                                      v-b-tooltip.hover
                                      :title="!remarkLoading[`step_${index}_remark`]
                                        ? (remarkTranslated[`step_${index}_remark`] ? $t('chat.revert') : $t('chat.translate'))
                                        : ''"
                                      variant="light"
                                      pill
                                      style="
                                        height: fit-content;
                                        width: fit-content;
                                        padding: 4px 8px;
                                        margin-right: 0.5rem;
                                        margin-left: 4px;
                                      "
                                      size="sm"
                                      @click="remarkTranslated[`step_${index}_remark`]
                                        ? revertRemark(index)
                                        : translateRemark(index, step.remark)"
                                    >
                                      <b-spinner v-if="remarkLoading[`step_${index}_remark`]" style="width: 14px; height: 14px;" label="loading"></b-spinner>
                                      <feather-icon v-else-if="remarkTranslated[`step_${index}_remark`]" icon="CornerUpLeftIcon" style="width: 14px; height: 14px;" />
                                      <translate-icon v-else style="width: 13px; height: 13px;" />
                                    </b-button>
                                  </div>
                                  <div>
                                    <div
                                      v-if="
                                        step.remarkMediaIds &&
                                          step.remarkMediaIds.length
                                      "
                                      class="file-list mt-1"
                                    >
                                      <div
                                        v-for="(
                                          { url, name }, idx
                                        ) in getVisibleFiles(
                                          step.remarkMediaIds
                                        )"
                                        :key="url + idx"
                                        class="file-item d-flex align-items-center"
                                      >
                                        <div
                                          class="file-preview cursor-pointer"
                                          @click="
                                            showMediaPreview(url, getVisibleFiles(step.remarkMediaIds, false))
                                          "
                                        >
                                          <img
                                            v-if="isImageFile(url)"
                                            :src="url"
                                            alt="preview"
                                          >
                                          <div
                                            v-else
                                            :style="{
                                              padding: '8px 3px',
                                              position: 'relative'
                                            }"
                                          >
                                            <file-icon
                                              :style="{ color: 'gray' }"
                                            />
                                            <span
                                              class="file-ext"
                                              :style="{ color: 'white' }"
                                            >
                                              {{ getFileExtDisplay(url) }}
                                            </span>
                                          </div>
                                        </div>
                                        <span
                                          class="ml-2 file-name cursor-pointer text-truncate"
                                          style="width: 400px"
                                          @click="
                                            showMediaPreview(url, getVisibleFiles(step.remarkMediaIds, false))
                                          "
                                        >
                                          {{ name }}
                                        </span>
                                      </div>

                                      <div
                                        v-if="getVisibleFiles(step.remarkMediaIds, false).length > 5 && !showAll"
                                        class="show-more-button mt-2 cursor-pointer"
                                        @click="showAll = true"
                                      >
                                        {{
                                          $t('general.showAllFiles', {
                                            count: getVisibleFiles(step.remarkMediaIds, false).length - 5
                                          })
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p
                      v-if="(helperList || []).length > 0"
                      class="detail-title"
                    >
                      {{ $t('general.helpers') }}
                    </p>
                    <div
                      v-for="helper in helperList"
                      :key="helper.id || helper._id"
                      class="chat-agent-detail detail-group-tab handling-by"
                    >
                      <div
                        class="helper-btn-groups"
                      >
                        <b-button
                          v-if="$can('manage', 'manage-modify-service') &&
                            (activeChannel.status === 'pending' ||
                              activeChannel.status === 'accepted' ||
                              activeChannel.status === 'processing' ||
                              activeChannel.status === 'hold')
                          "
                          size="sm"
                          class="btn"
                          style="border: #FF4141 1px solid !important; color: #FF4141 !important"
                          variant="outline-danger"
                          @click="handleDeleteHelper(helper.helperId)"
                        >
                          {{ $t('button.delete') }}
                        </b-button>
                        <b-button
                          v-if="$can('manage', 'manage-modify-service') &&
                            (activeChannel.status === 'pending' ||
                              activeChannel.status === 'accepted' ||
                              activeChannel.status === 'processing' ||
                              activeChannel.status === 'hold') &&
                            !(activeChannel.isMainOperatorCompleted && helper.status === 'completed')
                          "
                          size="sm"
                          class="btn"
                          style="border: #006BE5 1px solid !important; color: #006BE5 !important"
                          variant="outline-danger"
                          @click="replaceHelper(helper.helperId)"
                        >
                          {{ $t('button.replace') }}
                        </b-button>
                        <b-button
                          size="sm"
                          class="btn"
                          style="border: var(--primary) 1px solid !important; color: var(--primary) !important"
                          variant="outline-danger"
                          @click="openOperatorTrackerModal(helper.operatorId, helper)"
                        >
                          {{ $t('button.tracking') }}
                        </b-button>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.departmentName') }}</label>
                        <p
                          class="mb-0"
                          style="margin-right: 270px;"
                        >
                          {{ getDepartmentNames(helper.departments) }}
                        </p>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.operator') }}</label>
                        <div class="d-flex align-items-center">
                          <p
                            v-if="helper.operator.firstName || helper.operator.lastName || helper.operator.name"
                            class="mb-0 mr-1"
                            style="width: 200px"
                          >
                            <span v-if="helper.operator.name">
                              {{ helper.operator.name }}
                            </span>
                            <span v-else>
                              {{ [helper.operator.firstName, helper.operator.lastName].filter(Boolean).join(' ') }}
                            </span>
                          </p>
                          <p
                            v-else
                            class="mb-0 mr-1"
                            style="color: #e83e8c; width: 200px"
                          >
                            {{ $t('ticket.unassigned') }}
                          </p>
                        </div>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.status') }}</label>
                        <div class="d-flex align-items-center">
                          <div
                            class="mb-0 mr-1"
                            style="width: 200px"
                          >
                            <ServiceStatus :status="helper.status" />
                          </div>
                        </div>
                      </div>

                      <div class="detail-group">
                        <label>{{ $t('field.latest_tracking') }}</label>
                        <div
                          v-if="helper.lastTracking"
                          class="mb-0 tracking-item"
                          style="width: 100%"
                        >
                          <div
                            v-for="(step, index) in [helper.lastTracking]"
                            v-if="step"
                            :key="index"
                            class="step-card position-relative"
                          >
                            <!-- Step Number Badge -->
                            <!-- <div
                              class="step-number"
                              :class="`bg-${step.status}`"
                            >
                              <span>{{ index + 1 }}</span>
                            </div> -->

                            <!-- Vertical Line -->
                            <div v-if="index < helper.lastTracking.length - 1" />
                            <b-row>
                              <b-col>
                                <h6 :class="step.status">
                                  {{ $t(`status.${step.status}`) }}
                                </h6>
                                <p
                                  v-if="
                                    step.status === 'cancel' &&
                                      step.participant.participantType ===
                                      'customer'
                                  "
                                  v-html="
                                    $t(
                                      'statusDescription.cancelledByCustomer',
                                      {
                                        operator: step.participant.name
                                      }
                                    )
                                  "
                                />
                                <p
                                  v-else-if="
                                    step.status === 'assign' &&
                                      !step.isAutoAssign
                                  "
                                  v-html="
                                    getStatusDescription(
                                      'manualAssign',
                                      step.participant.name,
                                      getStepAssignOperatorId(step)
                                    )
                                  "
                                />
                                <div
                                  v-if="step.status === 'pending' && step.isAutoAssign"
                                  v-html="getStatusDescription('pendingSystem', step.assignedOperator, getStepAssignOperatorId(step))"
                                />
                                <div
                                  v-else-if="step.status === 'pending' && step.assignedBy"
                                  v-html="getStatusDescription('pendingHuman', getStepAssignedByOperatorName(step), getStepAssignedByOperatorId(step), step.assignedOperator, getStepAssignOperatorId(step))"
                                />
                                <div
                                  v-else-if="step.status === 'pending' && !step.isAutoAssign && !step.assignedBy"
                                  v-html="getStatusDescription('pendingHuman', step.assignedOperator, getStepAssignOperatorId(step), step.assignedOperator, getStepAssignOperatorId(step))"
                                />
                                <div
                                  v-else-if="step.status === 'cancel' && step.participant.participantType === 'cronJob'"
                                  v-html="$t('statusDescription.cancelSystem')"
                                />
                                <div
                                  v-else-if="step.status === 'pending'"
                                  class="mb-1"
                                  v-html="
                                    getStatusDescription(
                                      'pending',
                                      step.assignedOperator,
                                      getStepAssignOperatorId(step)
                                    )
                                  "
                                />
                                <p
                                  v-else
                                  class="mb-1"
                                  v-html="
                                    getStatusDescription(
                                      step.status,
                                      step.assignedOperator,
                                      getStepAssignOperatorId(step)
                                    )
                                  "
                                />
                                <div class="detail-group">
                                  <label>{{
                                    step.createdAt | formatDate
                                  }}</label>
                                </div>
                                <div
                                  v-if="step.isNoPriceSpecialists && step.isFinalCompleted"
                                >
                                  <div>
                                    <template v-if="step.status === 'completed' && !step.isFromHelper && !step.isPartialCompleted && step.servicePrice !== null">
                                      <strong>
                                        {{ $t('field.servicePrice') }}:
                                      </strong>
                                      {{
                                        !!step.servicePrice ||
                                          step.servicePrice === 0
                                          ? formatNumber(
                                            step.servicePrice,
                                            step.servicePriceCurrency
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                          : $t('general.not_available')
                                      }}
                                      <br>
                                      <div style="margin-top: 4px;" v-if="!!step.servicePriceInit">
                                        <strong>
                                          {{ $t('field.originalPrice') }}:
                                        </strong>
                                        {{
                                          formatNumber(
                                            step.servicePriceInit
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                        }}
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <div
                                  v-else-if="
                                    step.status === 'completed' ||
                                      step.status === 'cancel' ||
                                      step.status === 'hold'
                                  "
                                >
                                  <div>
                                    <template
                                      v-if="step.status === 'completed' && !step.isFromHelper && !step.isPartialCompleted && step.servicePrice !== null"
                                    >
                                      <strong>
                                        {{ $t('field.servicePrice') }}:
                                      </strong>
                                      {{
                                        !!step.servicePrice ||
                                          step.servicePrice === 0
                                          ? formatNumber(
                                            step.servicePrice,
                                            step.servicePriceCurrency
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                          : $t('general.not_available')
                                      }}
                                      <br>
                                      <div style="margin-top: 4px;" v-if="!!step.servicePriceInit">
                                        <strong>
                                          {{ $t('field.originalPrice') }}:
                                        </strong>
                                        {{
                                          formatNumber(
                                            step.servicePriceInit
                                          ) +
                                            ' ' +
                                            (step.servicePriceCurrency || '')
                                        }}
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <div
                                  v-if="
                                    (step.status === 'cancel' ||
                                      step.status === 'hold' ||
                                      step.status === 'completed') &&
                                      step.remark
                                  "
                                  class="mt-1"
                                >
                                  <div>
                                    <strong> {{ $t('field.remark') }}: </strong>
                                    <span>{{ step.remark || $t('general.not_available') }}</span>
                                    <b-button
                                      class="btn-translate"
                                      v-b-tooltip.hover
                                      :title="!remarkLoading[`helper_step_${index}_remark`]
                                        ? (remarkTranslated[`helper_step_${index}_remark`] ? $t('chat.revert') : $t('chat.translate'))
                                        : ''"
                                      variant="light"
                                      pill
                                      style="
                                        height: fit-content;
                                        width: fit-content;
                                        padding: 4px 8px;
                                        margin-right: 0.5rem;
                                        margin-left: 4px;
                                      "
                                      size="sm"
                                      @click="remarkTranslated[`helper_step_${index}_remark`]
                                        ? revertHelperRemark(index)
                                        : translateHelperRemark(index, step.remark)"
                                    >
                                      <b-spinner v-if="remarkLoading[`helper_step_${index}_remark`]" style="width: 14px; height: 14px;" label="loading"></b-spinner>
                                      <feather-icon v-else-if="remarkTranslated[`helper_step_${index}_remark`]" icon="CornerUpLeftIcon" style="width: 14px; height: 14px;" />
                                      <translate-icon v-else style="width: 13px; height: 13px;" />
                                    </b-button>
                                  </div>
                                  <div>
                                    <div
                                      v-if="
                                        step.remarkMediaIds &&
                                          step.remarkMediaIds.length
                                      "
                                      class="file-list mt-1"
                                    >
                                      <div
                                        v-for="(
                                          { url, name }, idx
                                        ) in getVisibleFiles(
                                          step.remarkMediaIds
                                        )"
                                        :key="url + idx"
                                        class="file-item d-flex align-items-center"
                                      >
                                        <div
                                          class="file-preview cursor-pointer"
                                          @click="
                                            showMediaPreview(url, getVisibleFiles(step.remarkMediaIds, false))
                                          "
                                        >
                                          <img
                                            v-if="isImageFile(url)"
                                            :src="url"
                                            alt="preview"
                                          >
                                          <div
                                            v-else
                                            :style="{
                                              padding: '8px 3px',
                                              position: 'relative'
                                            }"
                                          >
                                            <file-icon
                                              :style="{ color: 'gray' }"
                                            />
                                            <span
                                              class="file-ext"
                                              :style="{ color: 'white' }"
                                            >
                                              {{ getFileExtDisplay(url) }}
                                            </span>
                                          </div>
                                        </div>
                                        <span
                                          class="ml-2 file-name cursor-pointer text-truncate"
                                          style="width: 400px"
                                          @click="
                                            showMediaPreview(url, getVisibleFiles(step.remarkMediaIds, false))
                                          "
                                        >
                                          {{ name }}
                                        </span>
                                      </div>

                                      <div
                                        v-if="getVisibleFiles(step.remarkMediaIds, false).length > 5 && !showAll"
                                        class="show-more-button mt-2 cursor-pointer"
                                        @click="showAll = true"
                                      >
                                        {{
                                          $t('general.showAllFiles', {
                                            count: getVisibleFiles(step.remarkMediaIds, false).length - 5
                                          })
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                        <div
                          v-else
                          class="mb-0 tracking-item"
                          style="width: 100%; font-style: italic"
                        >
                          {{ $t('general.no_tracking') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </b-tab>
      <b-tab
        :title="$t('general.tracking')"
        style="overflow: auto"
        :active="activeTabState === 1"
      >
        <div
          class="tree-node accordion"
          role="tablist"
        >
          <b-card
            no-body
            class="mb-0"
            style="background-color: transparent"
          >
            <b-card-header
              header-tag="header"
              variant="info"
            >
              <div
                class="personal-info pt-0 chat-agent-detail"
                style="width: 100%"
              >
                <div class="list-unstyled detail-group">
                  <div style="display: flex; gap: 1em; flex-direction: column">
                    <div
                      class="step-list"
                      :style="{
                        paddingLeft: '40px'
                      }"
                    >
                      <div
                        v-for="(step, index) in messages"
                        :key="index"
                        class="step-card position-relative"
                      >
                        <!-- Step Number Badge -->
                        <div
                          class="step-number"
                          :class="`bg-${step.status}`"
                        >
                          <span>{{ index + 1 }}</span>
                        </div>

                        <!-- Vertical Line -->
                        <div
                          v-if="index < messages.length - 1"
                          class="step-connector"
                        />
                        <b-row>
                          <b-col>
                            <h6 :class="step.status">
                              {{ $t(`status.${step.status}`) }}
                            </h6>
                            <p
                              v-if="step.status === 'pending' && step.isAutoAssign"
                              v-html="getStatusDescription('pendingSystem', step.assignedOperator, getStepAssignOperatorId(step))"
                            />
                            <p
                              v-else-if="step.status === 'pending' && step.assignedBy"
                              v-html="getStatusDescription('pendingHuman', getStepAssignedByOperatorName(step), getStepAssignedByOperatorId(step), step.assignedOperator, getStepAssignOperatorId(step))"
                            />
                            <p
                              v-else-if="step.status === 'pending' && !step.isAutoAssign && !step.assignedBy"
                              v-html="getStatusDescription('pendingHuman', step.assignedOperator, getStepAssignOperatorId(step), step.assignedOperator, getStepAssignOperatorId(step))"
                            />
                            <p
                              v-else-if="step.status === 'cancel' && step.participant.participantType === 'cronJob'"
                              v-html="$t('statusDescription.cancelSystem')"
                            />
                            <p
                              v-else-if="step.status === 'replaced'"
                              v-html="getStatusDescription('replaced', step.transfer.fromOperator, step.transfer.fromOperatorId, step.transfer.toOperator, step.transfer.toOperatorId)"
                            />
                            <p
                              v-else-if="
                                step.status === 'cancel' &&
                                  step.participant.participantType === 'customer'
                              "
                              v-html="
                                $t('statusDescription.cancelledByCustomer', {
                                  operator: step.participant.name
                                })
                              "
                            />
                            <p
                              v-else-if="
                                step.status === 'assign' && !step.isAutoAssign
                              "
                              v-html="
                                getStatusDescription(
                                  'pending',
                                  step.participant.name,
                                  step.assignOperatorId
                                )
                              "
                            />
                            <p
                              v-else-if="step.status === 'deleted'"
                              v-html="getStatusDescription('deleted', step.transfer.fromOperator, step.transfer.fromOperatorId, step.transfer.toOperator, step.transfer.toOperatorId, step.meta.currentStatus)"
                            />
                            <div
                              v-else-if="step.status === 'pending'"
                              class="mb-1"
                              v-html="
                                getStatusDescription(
                                  'pending',
                                  step.assignedOperator,
                                  step.assignOperatorId
                                )
                              "
                            />
                            <p
                              v-else
                              class="mb-1"
                              v-html="
                                getStatusDescription(
                                  step.status,
                                  step.assignedOperator,
                                  step.assignOperatorId
                                )
                              "
                            />
                            <div class="detail-group">
                              <label>{{ step.createdAt | formatDate }}</label>
                            </div>
                            <div
                              v-if="step.isNoPriceSpecialists && step.isFinalCompleted"
                            >
                              <div>
                                <template>
                                  <template v-if="step.servicePrice !== null">
                                    <strong>
                                      {{ $t('field.servicePrice') }}:
                                    </strong>
                                    {{
                                      !!step.servicePrice ||
                                        step.servicePrice === 0
                                        ? formatNumber(
                                          step.servicePrice,
                                          step.servicePriceCurrency
                                        ) +
                                          ' ' +
                                          (step.servicePriceCurrency || '')
                                        : $t('general.not_available')
                                    }}
                                    <br>
                                  </template>
                                  <div style="margin-top: 4px;" v-if="!!step.servicePriceInit">
                                    <strong>
                                      {{ $t('field.originalPrice') }}:
                                    </strong>
                                    {{
                                      formatNumber(
                                        step.servicePriceInit
                                      ) +
                                        ' ' +
                                        (step.servicePriceCurrency || '')
                                    }}
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div
                              v-else-if="
                                step.status === 'completed' ||
                                  step.status === 'cancel' ||
                                  step.status === 'hold'
                              "
                            >
                              <div>
                                <template v-if="step.status === 'completed' && !step.isFromHelper && !step.isPartialCompleted && step.servicePrice !== null">
                                  <strong>
                                    {{ $t('field.servicePrice') }}:
                                  </strong>
                                  {{
                                    !!step.servicePrice ||
                                      step.servicePrice === 0
                                      ? formatNumber(
                                        step.servicePrice,
                                        step.servicePriceCurrency
                                      ) +
                                        ' ' +
                                        (step.servicePriceCurrency || '')
                                      : $t('general.not_available')
                                  }}
                                  <br>
                                  <div style="margin-top: 4px;" v-if="!!step.servicePriceInit">
                                    <strong>
                                      {{ $t('field.originalPrice') }}:
                                    </strong>
                                    {{
                                      formatNumber(
                                        step.servicePriceInit
                                      ) +
                                        ' ' +
                                        (step.servicePriceCurrency || '')
                                    }}
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div
                              v-if="
                                (step.status === 'completed' ||
                                  step.status === 'cancel' ||
                                  step.status === 'hold') &&
                                  step.remark
                              "
                              class="mt-1"
                            >
                              <div>
                                <strong> {{ $t('field.remark') }}: </strong>
                                <span>{{ step.remark || $t('general.not_available') }}</span>
                                <b-button
                                  class="btn-translate"
                                  v-b-tooltip.hover
                                  :title="!remarkLoading[`tracking_step_${index}_remark`]
                                    ? (remarkTranslated[`tracking_step_${index}_remark`] ? $t('chat.revert') : $t('chat.translate'))
                                    : ''"
                                  variant="light"
                                  pill
                                  style="
                                    height: fit-content;
                                    width: fit-content;
                                    padding: 4px 8px;
                                    margin-right: 0.5rem;
                                    margin-left: 4px;
                                  "
                                  size="sm"
                                  @click="remarkTranslated[`tracking_step_${index}_remark`]
                                    ? revertTrackingRemark(index)
                                    : translateTrackingRemark(index, step.remark)"
                                >
                                  <b-spinner v-if="remarkLoading[`tracking_step_${index}_remark`]" style="width: 14px; height: 14px;" label="loading"></b-spinner>
                                  <feather-icon v-else-if="remarkTranslated[`tracking_step_${index}_remark`]" icon="CornerUpLeftIcon" style="width: 14px; height: 14px;" />
                                  <translate-icon v-else style="width: 13px; height: 13px;" />
                                </b-button>
                              </div>
                              <div>
                                <div
                                  v-if="
                                    step.remarkMediaIds &&
                                      step.remarkMediaIds.length
                                  "
                                  class="file-list mt-1"
                                >
                                  <div
                                    v-for="(
                                      { url, name }, idx
                                    ) in getVisibleFiles(
                                      step.remarkMediaIds
                                    )"
                                    :key="url + idx"
                                    class="file-item d-flex align-items-center"
                                  >
                                    <div
                                      class="file-preview cursor-pointer"
                                      @click="
                                        showMediaPreview(url, getVisibleFiles(step.remarkMediaIds, false))
                                      "
                                    >
                                      <img
                                        v-if="isImageFile(url)"
                                        :src="url"
                                        alt="preview"
                                      >
                                      <div
                                        v-else
                                        :style="{
                                          padding: '8px 3px',
                                          position: 'relative'
                                        }"
                                      >
                                        <file-icon :style="{ color: 'gray' }" />
                                        <span
                                          class="file-ext"
                                          :style="{ color: 'white' }"
                                        >
                                          {{ getFileExtDisplay(url) }}
                                        </span>
                                      </div>
                                    </div>
                                    <span
                                      class="ml-2 file-name cursor-pointer text-truncate"
                                      style="width: 400px"
                                      @click="
                                        showMediaPreview(url, getVisibleFiles(step.remarkMediaIds, false))
                                      "
                                    >
                                      {{ name }}
                                    </span>
                                  </div>

                                  <div
                                    v-if="fileList.length > 5 && !showAll"
                                    class="show-more-button mt-2 cursor-pointer"
                                    @click="showAll = true"
                                  >
                                    {{
                                      $t('general.showAllFiles', {
                                        count: fileList.length - 5
                                      })
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-header>
          </b-card>
        </div>
      </b-tab>
      <b-tab
        :title="$t('general.initiator')"
        :active="activeTabState === 2"
        style="overflow: auto"
      >
        <div
          class="tree-node accordion"
          role="tablist"
        >
          <b-card
            no-body
            class="mb-0"
            style="background-color: transparent"
          >
            <div
              header-tag="header"
              variant="info"
            >
              <div
                class="personal-info pt-0"
                style="width: 100%; display: flex; flex-direction: column; gap: 1em"
              >
                <p class="detail-title">
                  {{ $t('chat.information') }}
                </p>
                <div class="chat-agent-detail detail-group-tab">
                  <div class="detail-group">
                    <label>{{ $t('general.profile') }}</label>
                    <div class="name-initiator">
                      <b-avatar
                        :src="
                          activeChannel.meta && activeChannel.meta.profileUrl
                        "
                        size="2rem"
                        variant="primary"
                      />
                      <span class="ml-1">{{ customerName }}</span>
                    </div>
                  </div>

                  <div
                    v-if="activeChannel.origin"
                    class="detail-group"
                  >
                    <label>{{ $t('field.origin') }}</label>
                    <p class="mb-0">
                      {{ getOrigin(activeChannel) }}
                    </p>
                  </div>

                  <div
                    v-if="
                      activeChannel.customer && activeChannel.customer.email
                    "
                    class="detail-group"
                  >
                    <label>{{ $t('field.email') }}</label>
                    <p class="mb-0">
                      {{
                        (activeChannel.customer &&
                          activeChannel.customer.email) ||
                          $t('general.not_available')
                      }}
                    </p>
                  </div>

                  <div
                    v-if="
                      activeChannel.customer && activeChannel.customer.phone
                    "
                    class="detail-group"
                  >
                    <label>{{ $t('field.phoneNumber') }}</label>
                    <p class="mb-0">
                      {{
                        (activeChannel.customer &&
                          activeChannel.customer.phone) ||
                          $t('general.not_available')
                      }}
                    </p>
                  </div>

                  <div
                    v-if="
                      activeChannel.customer && activeChannel.customer.address
                    "
                    class="detail-group"
                  >
                    <label>{{ $t('field.address') }}</label>
                    <p class="mb-0">
                      {{
                        (activeChannel.customer &&
                          activeChannel.customer.address) ||
                          $t('general.not_available')
                      }}
                    </p>
                  </div>

                  <div
                    v-if="
                      activeChannel.customer && activeChannel.customer.device
                    "
                    class="detail-group"
                  >
                    <label>{{ $t('chat.device') }}</label>
                    <p class="mb-0">
                      {{
                        (activeChannel.customer &&
                          activeChannel.customer.device) ||
                          $t('general.not_available')
                      }}
                    </p>
                  </div>

                  <div
                    v-if="
                      activeChannel.customer && activeChannel.customer.ipAddress
                    "
                    class="detail-group"
                  >
                    <label>{{ $t('field.ipAddress') }}</label>
                    <p class="mb-0">
                      {{
                        (activeChannel.customer &&
                          activeChannel.customer.ipAddress) ||
                          $t('general.not_available')
                      }}
                    </p>
                  </div>

                  <div v-if="activeChannel.origin === 'chatagent'" class="detail-group">
                    <label>{{ $t('general.chatflow') }}</label>
                    <p class="mb-0" style="cursor: pointer; text-decoration: underline;" @click="showChatflowModal = true">{{$t('general.viewLogs')}}</p>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </b-tab>
    </b-tabs>

    <image-preview
      :image="image"
      @close="image = ''"
    />

    <!-- Original Image Preview Modal -->
    <b-modal
      v-model="isModalVisible"
      size="lg"
      centered
      hide-footer
      class="image-modal"
      body-class="modal-img-content"
      @hidden="resetModal"
    >
      <div class="modal-image-container">
        <div
          v-if="fileList.length > 1"
          class="nav-button prev-button"
          :class="{ disabled: currentImageIndex === 0 }"
          @click="prevImage"
        >
          <feather-icon
            size="32"
            icon="ChevronLeftIcon"
          />
        </div>
        <div class="image-wrapper">
          <img
            v-if="fileList[currentImageIndex]"
            :src="fileList[currentImageIndex]"
            class="preview-one"
            alt="Full Image"
          >
        </div>
        <div
          v-if="fileList.length > 1"
          class="nav-button next-button"
          :class="{ disabled: currentImageIndex === fileList.length - 1 }"
          @click="nextImage"
        >
          <feather-icon
            size="32"
            icon="ChevronRightIcon"
          />
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="isMediaModalVisible"
      size="lg"
      centered
      hide-footer
      class="media-modal"
      body-class="modal-media-content"
      @hidden="resetMediaModal"
    >
      <div class="modal-media-container">
        <div
          v-if="mediaList.length > 1"
          class="nav-button prev-button"
          :class="{ disabled: currentMediaIndex === 0 }"
          @click="prevMedia"
        >
          <feather-icon
            size="32"
            icon="ChevronLeftIcon"
          />
        </div>
        <div class="media-wrapper">
          <template v-if="mediaList[currentMediaIndex]">
            <img
              v-if="(mediaList[currentMediaIndex].mimeType || []).includes('image/')"
              :src="mediaList[currentMediaIndex].url"
              class="preview-one"
              alt="Full Image"
            >
            <video
              v-else-if="
                (mediaList[currentMediaIndex].mimeType || []).includes('video/')
              "
              :src="mediaList[currentMediaIndex].url"
              class="preview-one video-preview"
              controls
              autoplay
            />
            <audio
              v-else-if="
                (mediaList[currentMediaIndex].mimeType || []).includes('audio/')
              "
              :src="mediaList[currentMediaIndex].url"
              class="preview-one audio-preview"
              controls
              autoplay
            />
            <div
              v-else
              class="preview-one file-preview-fallback"
              style="
                display: flex;
                gap: 0.5rem;
                align-items: center;
                cursor: pointer;
              "
              @click="openFile(mediaList[currentMediaIndex].url)"
            >
              <div
                :style="{
                  padding: '8px 3px',
                  position: 'relative',
                  display: 'flex',
                  'justify-content': 'center'
                }"
              >
                <file-icon :style="{ color: 'gray' }" />
                <span
                  class="file-ext"
                  :style="{ color: 'white' }"
                >
                  {{ getFileExtDisplay(mediaList[currentMediaIndex].url) }}
                </span>
              </div>
              <div
                class="file-name"
                style="margin-top: 0"
              >
                {{ getMediaNameOrUrl(mediaList[currentMediaIndex]) }}
              </div>
            </div>
          </template>
        </div>
        <div
          v-if="mediaList.length > 1"
          class="nav-button next-button"
          :class="{ disabled: currentMediaIndex === mediaList.length - 1 }"
          @click="nextMedia"
        >
          <feather-icon
            size="32"
            icon="ChevronRightIcon"
          />
        </div>
      </div>
    </b-modal>

    <!-- Chatflow Modal -->
    <b-modal
      v-model="showChatflowModal"
      size="lg"
      centered
      hide-footer
      class="chatflow-modal"
    >
      <template #modal-title>
        <span>{{ $t('general.chatflow') }}</span>
        <span class="italic">&nbsp;({{ $t('general.forTechnicalSupportOnly') }})</span>
      </template>
      <div
        class="tree-node accordion"
        role="tablist"
      >
        <b-card
          no-body
          class="mb-0"
          style="background-color: #f8f8f8"
        >
          <b-card-header
            header-tag="header"
            variant="info"
          >
            <div
              class="personal-info pt-0"
              style="width: 100%"
            >
              <div
                class="tree-node accordion"
                role="tablist"
              >
                <div v-if="!activeChannel.params.length">
                  <b-card
                    style="
                      width: 100%;
                      border-radius: 8px;
                      margin-bottom: 16px;
                    "
                  >
                    <b-row class="chat-agent-detail">
                      <b-col md="12">
                        <div
                          class="detail-group"
                          style="text-align: center"
                        >
                          {{ $t('general.not_available') }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
                <div class="detail-group">
                  <div
                    v-if="!activeChannel.isNoChatChannel"
                    class="mb-0"
                  >
                    <div
                      class="chat-agent-card"
                      v-for="(param, index) in activeChannel.params"
                      :key="param + index"
                    >
                      <b-card
                        style="
                          width: 100%;
                          border-radius: 8px;
                          margin-bottom: 0;
                        "
                      >
                        <b-row class="chat-agent-detail">
                          <b-col
                            md="12"
                            class="mb-1"
                          >
                            <div class="detail-group">
                              <label style="text-transform: capitalize">
                                {{ param.name }}
                              </label>
                              <p class="mb-0 capitalize-first">
                                {{ param.description }}
                              </p>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row
                          v-if="param.responseParams"
                          class="chat-agent-detail"
                        >
                          <b-col
                            md="12"
                            class="mb-1"
                          >
                            <div class="detail-group">
                              <label>
                                {{ $t('general.response') }}
                              </label>
                              <div
                                v-for="parameter in param.parameters"
                                :key="parameter.key"
                                class="mb-0"
                              >
                                <div>
                                  <span
                                    class="capitalize-first"
                                  >{{ parameter.key }}:</span>
                                  <code
                                    style="
                                      margin-left: 4px;
                                      padding: 1px 5px 1px 1px;
                                    "
                                  >
                                    {{ mappedValue(param, parameter) }}
                                  </code>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                  </div>
                  <div
                    v-if="activeChannel.isNoChatChannel"
                    class="mb-0"
                  >
                    <div
                      v-for="(param, index) in activeChannel.params"
                      :key="param + index"
                    >
                      <b-card
                        style="
                          width: 100%;
                          border-radius: 8px;
                          margin-bottom: 16px;
                        "
                      >
                        <b-row
                          v-if="param.responseParams"
                          class="chat-agent-detail"
                        >
                          <b-col
                            md="12"
                            class="mb-1"
                          >
                            <div class="detail-group">
                              <label>
                                {{ $t('general.response') }}
                              </label>
                              <div
                                v-for="parameter in param.parameters"
                                :key="parameter.key"
                                class="mb-0"
                              >
                                <div :style="{ paddingBottom: '5px' }">
                                  <span>{{ getParamName(parameter) }}:</span>
                                  <div
                                    v-if="
                                      getResponse(
                                        param.responseParams[parameter.key]
                                      ).type === 'files'
                                    "
                                  >
                                    <div class="file-list mt-1">
                                      <div
                                        v-for="(
                                          { url, mimeType }, idx
                                        ) in getResponse(
                                          param.responseParams[parameter.key]
                                        ).files"
                                        :key="url + idx"
                                        class="file-item d-flex align-items-center"
                                      >
                                        <div
                                          class="file-preview cursor-pointer"
                                          @click="
                                            showMediaPreview(
                                              url,
                                              getResponse(
                                                param.responseParams[
                                                  parameter.key
                                                ]
                                              ).files
                                            )
                                          "
                                        >
                                          <img
                                            v-if="(mimeType || []).includes('image/')"
                                            :src="url"
                                            alt="preview"
                                          >
                                          <div
                                            v-else-if="
                                              (mimeType || []).includes('video/')
                                            "
                                            :style="{
                                              padding: '8px 3px',
                                              position: 'relative'
                                            }"
                                          >
                                            <feather-icon
                                              icon="VideoIcon"
                                              size="20"
                                            />
                                          </div>
                                          <div
                                            v-else-if="
                                              (mimeType || []).includes('audio/')
                                            "
                                            :style="{
                                              padding: '8px 3px',
                                              position: 'relative'
                                            }"
                                          >
                                            <feather-icon
                                              icon="MicIcon"
                                              size="20"
                                            />
                                          </div>
                                          <div
                                            v-else
                                            :style="{
                                              padding: '8px 3px',
                                              position: 'relative'
                                            }"
                                          >
                                            <file-icon
                                              :style="{ color: 'gray' }"
                                            />
                                            <span
                                              class="file-ext"
                                              :style="{ color: 'white' }"
                                            >
                                              {{ getFileExtDisplay(url) }}
                                            </span>
                                          </div>
                                        </div>
                                        <span
                                          class="ml-2 file-name cursor-pointer text-truncate"
                                          style="width: 400px"
                                          @click="
                                            showMediaPreview(
                                              url,
                                              getResponse(
                                                param.responseParams[
                                                  parameter.key
                                                ]
                                              ).files
                                            )
                                          "
                                        >
                                          {{ $t('general.view') }}
                                        </span>
                                      </div>

                                      <div
                                        v-if="
                                          getResponse(
                                            param.responseParams[
                                              parameter.key
                                            ]
                                          ).files.length > 5 && !showAll
                                        "
                                        class="show-more-button mt-2 cursor-pointer"
                                        @click="showAll = true"
                                      >
                                        {{
                                          $t('general.showAllFiles', {
                                            count:
                                              getResponse(
                                                param.responseParams[
                                                  parameter.key
                                                ]
                                              ).files.length - 5
                                          })
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <code
                                    v-else-if="getType(parameter) === 'text'"
                                    style="
                                      margin-left: 4px;
                                      padding: 1px 5px 1px 1px;
                                    "
                                  >
                                    {{
                                      getResponse(
                                        param.responseParams[parameter.key]
                                      )
                                    }}
                                  </code>
                                  <span
                                    v-else-if="getType(parameter) === 'link'"
                                  >
                                    <a
                                      :href="
                                        getResponse(
                                          param.responseParams[parameter.key]
                                        )
                                      "
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      class="text-primary"
                                    >
                                      {{
                                        getResponse(
                                          param.responseParams[parameter.key]
                                        )
                                      }}
                                    </a>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-header>
        </b-card>
      </div>
    </b-modal>

    <EmployeeDetailModal
      ref="employeeDetailModal"
      modal-id="employee-detail-modal"
    />

    <OperatorTrackerModal
      ref="operatorTrackerModal"
      modal-id="operator-tracker-modal"
    />

    <ReplaceOperatorModal
      ref="replaceOperatorModal"
      modal-id="replace-operator-modal"
      :must-excluded-ids="mustExcludedIds"
      @success="$emit('success')"
    />
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BDropdown,
  BDropdownItem,
  BPopover,
  BSpinner,
  BTab,
  BTabs,
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BBadge,
  BModal,
  BImg,
} from 'bootstrap-vue'
import messageStatus from '@/data/messageStatus'
import messageType from '@/data/messageType'
import conversationStatus from '@/data/conversationStatus'
import languageEn from '@/data/languages/en'
import CsvIcon from '@/components/icons/CsvIcon.vue'
import FileIcon from '@/components/icons/FileIcon.vue'
import ExcellIcon from '@/components/icons/ExcellIcon.vue'
import MsWordIcon from '@/components/icons/MsWordIcon.vue'
import PdfIcon from '@/components/icons/PdfIcon.vue'
import {
  getCountryByLanguageCode,
  formatDate as FormatDate,
} from '@/libs/helper'
import localeCountries from '@/data/localeCountries'
import useJwt from '@/auth/jwt/useJwt'
import Repository from '@/repositories/RepositoryFactory'
import WaveSurferVoice from '@/components/WaveSurferVoice.vue'
import { camelize, decamelize } from 'humps'
import { formatNumber } from '@/@core/utils/utils'
import {
  isVideo,
  isDoc,
  isImage,
  isCsv,
  isExcel,
  isPdf,
  isWord,
  isAudio,
  getFileExtDisplay,
} from '@/helpers/fileHelper'
import useAppStore from '@/store-pinia/useAppStore'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import ImagePreview from './ImagePreview.vue'
import ServiceStatus from './components/ServiceStatus.vue'
import EmployeeDetailModal from './components/EmployeeDetailModal.vue'
import OperatorTrackerModal from './components/OperatorTrackerModal.vue'
import ReplaceOperatorModal from './components/ReplaceOperatorModal.vue'
import TranslateIcon from '@/components/icons/TranslateIcon.vue'

const TranslateRepository = Repository.get('translateRepository')
const ChatMessageRepository = Repository.get('chatMessage')
const ServiceSystemRepository = Repository.get('serviceSystem')

export default {
  components: {
    BAvatar,
    ImagePreview,
    BButton,
    BDropdown,
    BDropdownItem,
    BPopover,
    BSpinner,
    BTab,
    BTabs,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BBadge,
    BModal,

    CsvIcon,
    ExcellIcon,
    MsWordIcon,
    PdfIcon,
    FileIcon,
    WaveSurferVoice,
    ServiceStatus,
    BImg,
    EmployeeDetailModal,
    OperatorTrackerModal,
    ReplaceOperatorModal,
    TranslateIcon,
  },
  props: {
    activeTab: {
      type: Number,
      default: 0,
    },
    nestedActiveTab: {
      type: Number,
      default: 0,
    },
    activeChannel: {
      type: Object,
      default: () => ({}),
    },
    messages: {
      type: Array,
      default: () => [],
    },
    readMessage: {
      type: String,
      default: '',
    },
    isTyping: {
      type: Boolean,
      default: false,
    },
    helperList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      image: '',
      activeTabState: 0,
      nestedActiveTabState: 0,
      messageStatus,
      messageType,
      conversationStatus,
      loading: {},
      transcribeContent: {},
      showTranscribe: {},
      transcribeLoading: {},
      transcribeError: {},
      camelize,
      decamelize,
      showAll: false,
      isModalVisible: false,
      currentImageIndex: 0,
      fileList: [],
      connectorHeight: [],
      formatNumber,
      isMediaModalVisible: false,
      currentMediaIndex: 0,
      mediaList: [],
      // param translation states
      paramTranslate: {},
      paramLoading: {},
      paramOriginal: {},
      paramTranslated: {},
      // remark translation states
      remarkTranslate: {},
      remarkLoading: {},
      remarkOriginal: {},
      remarkTranslated: {},
      showChatflowModal: false,
    }
  },
  computed: {
    customerName() {
      const name = this.activeChannel?.meta?.name || this.activeChannel?.customer?.name
      if (typeof name === 'object') {
        return name?.[this.currentLocale] || name?.en || name?.zh || name?.km || name?.vi || '-'
      }
      return name || '-'
    },
    subTypes() {
      return this.activeChannel.serviceSubTypes?.map(subType => subType.name?.[this.currentLocale] || subType.name?.en || subType.name?.zh || subType.name?.km || subType.name?.vi).filter(Boolean)
    },
    mustExcludedIds() {
      return [this.activeChannel.assignedOperatorId, ...(this.activeChannel?.helperOperatorIds || [])].filter(Boolean)
    },
    mainOperatorStatus() {
      return this.activeChannel.status === 'processing' && this.activeChannel.isMainOperatorCompleted ? this.detailTrackingList?.[0]?.status : this.activeChannel.status
    },
    isHelper() {
      return (this.activeChannel?.helperOperatorIds || [])?.includes(this.userData.id)
    },
    modalTitle() {
      if (this.activeChannel.status === 'pending') {
        return 'reassignOperator'
      }
      if (this.activeChannel.status === 'pendingDispatch') {
        return 'assignOperator'
      }
      return 'restart'
    },
    titleComputed() {
      if (this.modalTitle === 'resetPrice') {
        return this.$t('general.modal_title_reset_price')
      }
      if (this.modalTitle === 'reassignOperator') {
        return this.$t('general.modal_title_reassign_operator')
      }
      if (this.modalTitle === 'reassignPriceSpecialist') {
        return this.$t('general.modal_title_reassign_price_specialist')
      }
      if (this.modalTitle === 'assignOperator') {
        return this.$t('general.modal_title_assign_operator')
      }
      if (this.modalTitle === 'assignPriceSpecialist') {
        return this.$t('general.modal_title_assign_price_specialist')
      }

      return this.$t('general.modal_title_restart_service')
    },
    currentLocale() {
      return this.$i18n.locale.split('-')[0]
    },
    detailTrackingList() {
      if (this.activeChannel?.status === 'pendingPrice') {
        return [this.messages[this.messages.length - 1]]
      }

      const msgs = this.messages.filter(message => message?.assignOperatorId === this.activeChannel.assignedOperatorId)
      const result = [msgs[msgs.length - 1]].filter(Boolean)

      return result?.length > 0 ? (result || []) : (this.activeChannel.lastTracking || [])
    },
    hasMetaData() {
      return (
        this.activeChannel.finalResultParams
          && Object.keys(this.activeChannel.finalResultParams)?.length > 0
      )
    },
    isWaterService() {
      const code = this.activeChannel?.serviceType?.code || this.activeChannel?.serviceTypeCode
      return code === 'WATER_DELIVERY_ORDER'
    },
    filteredParams() {
      // Use simplified normalization when origin is chatagent
      if (this.activeChannel?.origin === 'chatagent') {
        const rawParams = this.activeChannel.finalResultParams || {}
        const normalized = {}
        const files = []

        const addFile = (url, mimeType) => {
          if (!url) return
          let detectedMime = mimeType || ''
          if (!detectedMime) {
            if (isImage(url)) detectedMime = 'image/'
            else if (isVideo(url)) detectedMime = 'video/'
            else if (isAudio(url)) detectedMime = 'audio/'
            else detectedMime = ''
          }
          files.push({ url, mimeType: detectedMime })
        }

        Object.entries(rawParams).forEach(([key, value]) => {
          const lowerKey = String(key || '').toLowerCase()

          // Collect any media-like entries into files
          if (lowerKey === 'files') {
            if (Array.isArray(value)) {
              value.forEach(v => {
                if (!v) return
                if (typeof v === 'string') addFile(v)
                else if (typeof v === 'object') addFile(v.url || v.name || '', v.mimeType)
              })
            } else if (typeof value === 'string') {
              addFile(value)
            }
            return
          }

          if (typeof value === 'string') {
            const looksMedia = isImage(value) || isVideo(value) || isAudio(value) || isDoc(value)
            const likelyMediaKey = [
              'image', 'image_url', 'imageurl', 'image-detail', 'image_detail', 'photo', 'picture', 'thumbnail',
              'video', 'video_url', 'videourl', 'voice', 'voice_url', 'audio', 'audio_url',
              'file', 'file_url', 'document', 'attachment', 'media', 'media_url', 'mediaurl'
            ].includes(lowerKey)

            if (looksMedia || likelyMediaKey) {
              addFile(value)
              return
            }
          }

          // Keep other valid values
          if (this.isValidValue(value)) {
            normalized[key] = value
          }
        })

        if (files.length > 0) {
          normalized.files = files
        }

        return normalized
      }

      const resolveLocaleValue = (val) => {
        if (val == null) return val
        if (typeof val === 'object') {
          // Multilingual object
          if (Object.prototype.hasOwnProperty.call(val, this.currentLocale)
            || Object.prototype.hasOwnProperty.call(val, 'en')) {
            return val[this.currentLocale] || val.en || val.vi || val.km || val.zh
          }
        }
        return val
      }

      // Prefer new params shape from activeChannel.params
      const paramGroups = Array.isArray(this.activeChannel?.params) ? this.activeChannel.params : []
      const latestGroup = paramGroups.length > 0 ? paramGroups[paramGroups.length - 1] : null
      const parameters = Array.isArray(latestGroup?.parameters) ? latestGroup.parameters : null
      const responseParams = latestGroup?.responseParams || null

      const normalized = {}
      const files = []

      const addFile = (url, mimeType) => {
        if (!url) return
        let detectedMime = mimeType || ''
        if (!detectedMime) {
          if (isImage(url)) detectedMime = 'image/'
          else if (isVideo(url)) detectedMime = 'video/'
          else if (isAudio(url)) detectedMime = 'audio/'
          else detectedMime = ''
        }
        files.push({ url, mimeType: detectedMime })
      }
      
      if (parameters && responseParams) {
        parameters.forEach(p => {
          const key = p?.key
          if (!key) return
          const type = (p?.type || 'text').toLowerCase()
          const value = responseParams[key]

          if (type === 'file') {
            const fileList = Array.isArray(p?.files) ? p.files : (Array.isArray(value) ? value : [])
            fileList.forEach(f => {
              if (!f) return
              if (typeof f === 'string') addFile(f)
              else if (typeof f === 'object') addFile(f.url || f.name || '', f.mimeType)
            })
            return
          }

          // Resolve per-locale value for multilingual objects
          const resolved = resolveLocaleValue(value)
          if (this.isValidValue(resolved, key)) {
            normalized[key] = resolved
          }
        })
      } else {
        // Fallback to legacy finalResultParams
        const rawParams = this.activeChannel.finalResultParams || {}
        Object.entries(rawParams).forEach(([key, value]) => {
          const lowerKey = String(key || '').toLowerCase()
          if (lowerKey === 'files') {
            if (Array.isArray(value)) {
              value.forEach(v => {
                if (!v) return
                if (typeof v === 'string') addFile(v)
                else if (typeof v === 'object') addFile(v.url || v.name || '', v.mimeType)
              })
            } else if (typeof value === 'string') {
              addFile(value)
            }
            return
          }
          if (typeof value === 'string') {
            const looksMedia = isImage(value) || isVideo(value) || isAudio(value) || isDoc(value)
            const likelyMediaKey = [
              'image', 'image_url', 'imageurl', 'image-detail', 'image_detail', 'photo', 'picture', 'thumbnail',
              'video', 'video_url', 'videourl', 'voice', 'voice_url', 'audio', 'audio_url',
              'file', 'file_url', 'document', 'attachment', 'media', 'media_url', 'mediaurl'
            ].includes(lowerKey)
            if (looksMedia || likelyMediaKey) {
              addFile(value)
              return
            }
          }
          const resolved = resolveLocaleValue(value)
          if (this.isValidValue(resolved, key)) {
            normalized[key] = resolved
          }
        })
      }

      if (files.length > 0) {
        normalized.files = files
      }

      return normalized
    },
    userData() {
      return this.$store.state.profile.email
          || this.$store.state.profile.phone
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
    canEditOperator() {
      return (
        this.$can('manage', 'manage-modify-service')
          && this.activeChannel.status !== 'resolved'
          && this.activeChannel.status !== 'cancel'
      )
    },
    canEditStatus() {
      return (
        this.$can('manage', 'manage-modify-service')
          && this.activeChannel.status !== 'resolved'
          && this.activeChannel.status !== 'cancelled'
      )
    },
    hasBuildingName() {
      return this.activeChannel.meta?.buildingName || this.activeChannel.meta?.translation?.buildingName
    },
    hasRoomName() {
      return this.activeChannel.meta?.roomName || this.activeChannel.meta?.translation?.roomName
    },
    hasEnterpriseName() {
      return this.activeChannel.meta?.enterpriseName || this.activeChannel.meta?.translation?.enterpriseName
    },
  },
  watch: {
    'activeChannel.id': {
      immediate: true,
      handler(value) {
        if (value) {
          this.paramTranslated = {}
          this.remarkTranslated = {}
        }
      },
    },
    'appStore.isServiceContentVisible': {
      immediate: true,
      handler(value) {
        this.paramTranslated = {}
        this.remarkTranslated = {}
        this.showAll = false
        setTimeout(() => {
          ServiceSystemRepository.getHelpers({
            serviceSystemId: this.activeChannel.id,
          }).then(response => {
            this.$emit('update-helper-list', response.data.data.list || [])
          })
        }, 100)

        if (!value && this.$route.query.serviceSystemId) {
          this.$emit('filter', {
            reset: true,
          })
        }
      },
    },
    activeTab: {
      immediate: true,
      handler(value) {
        this.activeTabState = value
      },
    },
    activeTabState(value) {
      this.$emit('change-active-tab', value)
    },
    nestedActiveTab: {
      immediate: true,
      handler(value) {
        this.nestedActiveTabState = value
      },
    },
    nestedActiveTabState(value) {
      this.$emit('change-nested-active-tab', value)
    },
  },
  mounted() {
    // Add global function to handle click since v-html doesn't support Vue events
    window.routeToOperator = operatorId => {
      if (!operatorId) return
      this.handleShowEmployeeDetailModal(operatorId)
    }
  },
  beforeDestroy() {
    // Clean up global function
    delete window.routeToOperator
  },
  methods: {
    getAddressLabel(address) {
      if (!address) return '-'
      if (typeof address === 'object') {
        return address?.[this.currentLocale] || address?.en || address?.zh || address?.km || address?.vi || address?.name || ''
      }
      return address || '-'
    },
    translateParam(key, text, param) {
      if (!key || !text) return
      if (this.paramLoading[key]) return
      this.$set(this.paramLoading, key, true)
      const target = this.$i18n.locale
      const setValue = (container, k, val) => {
        if (!container || typeof container !== 'object') return
        const camelKey = this.camelize ? this.camelize(k) : k
        if (camelKey in container) this.$set(container, camelKey, val)
        if (k in container) this.$set(container, k, val)
      }

      TranslateRepository.translate({ text, target })
        .then(response => {
          const translated = response?.data?.data?.translatedMessage || text
          this.$set(this.paramTranslate, key, translated)

          try {
            // Save original only once
            if (!(key in this.paramOriginal)) {
              this.$set(this.paramOriginal, key, text)
            }
            // 1) If a specific param group is provided, update it
            if (param && param.responseParams) {
              setValue(param.responseParams, key, translated)
            }

            // 2) Update latest params group on activeChannel if available
            const paramGroups = Array.isArray(this.activeChannel?.params) ? this.activeChannel.params : []
            const latestGroup = paramGroups.length > 0 ? paramGroups[paramGroups.length - 1] : null
            if (latestGroup && latestGroup.responseParams) {
              setValue(latestGroup.responseParams, key, translated)
            }

            // 3) Fallback to legacy finalResultParams
            if (this.activeChannel && this.activeChannel.finalResultParams) {
              setValue(this.activeChannel.finalResultParams, key, translated)
            }
          } catch (e) {}

          this.$set(this.paramTranslated, key, true)
          this.$set(this.paramLoading, key, false)
        })
        .catch(() => {
          this.$set(this.paramLoading, key, false)
        })
    },
    revertParam(key, param) {
      if (!key) return
      if (this.paramLoading[key]) return
      const original = this.paramOriginal[key]
      if (original == null) return
      const setValue = (container, k, val) => {
        if (!container || typeof container !== 'object') return
        const camelKey = this.camelize ? this.camelize(k) : k
        if (camelKey in container) this.$set(container, camelKey, val)
        if (k in container) this.$set(container, k, val)
      }
      try {
        if (param && param.responseParams) {
          setValue(param.responseParams, key, original)
        }
        const paramGroups = Array.isArray(this.activeChannel?.params) ? this.activeChannel.params : []
        const latestGroup = paramGroups.length > 0 ? paramGroups[paramGroups.length - 1] : null
        if (latestGroup && latestGroup.responseParams) {
          setValue(latestGroup.responseParams, key, original)
        }
        if (this.activeChannel && this.activeChannel.finalResultParams) {
          setValue(this.activeChannel.finalResultParams, key, original)
        }
      } catch (e) {}
      this.$delete(this.paramTranslate, key)
      this.$set(this.paramTranslated, key, false)
    },
    translateRemark(stepIndex, remark) {
      if (!remark) return
      const key = `step_${stepIndex}_remark`
      if (this.remarkLoading[key]) return
      
      this.$set(this.remarkLoading, key, true)
      const target = this.$i18n.locale

      TranslateRepository.translate({ text: remark, target })
        .then(response => {
          const translated = response?.data?.data?.translatedMessage || remark
          this.$set(this.remarkTranslate, key, translated)

          // Save original only once
          if (!(key in this.remarkOriginal)) {
            this.$set(this.remarkOriginal, key, remark)
          }

          // Update the remark in the tracking list
          this.$set(this.detailTrackingList[stepIndex], 'remark', translated)
          this.$set(this.remarkTranslated, key, true)
          this.$set(this.remarkLoading, key, false)
        })
        .catch(() => {
          this.$set(this.remarkLoading, key, false)
        })
    },
    revertRemark(stepIndex) {
      const key = `step_${stepIndex}_remark`
      if (this.remarkLoading[key]) return
      
      const original = this.remarkOriginal[key]
      if (original == null) return

      // Restore original remark
      this.$set(this.detailTrackingList[stepIndex], 'remark', original)
      this.$delete(this.remarkTranslate, key)
      this.$set(this.remarkTranslated, key, false)
    },
    translateHelperRemark(stepIndex, remark) {
      if (!remark) return
      const key = `helper_step_${stepIndex}_remark`
      if (this.remarkLoading[key]) return
      
      this.$set(this.remarkLoading, key, true)
      const target = this.$i18n.locale

      TranslateRepository.translate({ text: remark, target })
        .then(response => {
          const translated = response?.data?.data?.translatedMessage || remark
          this.$set(this.remarkTranslate, key, translated)

          // Save original only once
          if (!(key in this.remarkOriginal)) {
            this.$set(this.remarkOriginal, key, remark)
          }

          // Update the remark in the helper tracking list
          this.$set(this.helperList[stepIndex].lastTracking, 'remark', translated)
          this.$set(this.remarkTranslated, key, true)
          this.$set(this.remarkLoading, key, false)
        })
        .catch(() => {
          this.$set(this.remarkLoading, key, false)
        })
    },
    revertHelperRemark(stepIndex) {
      const key = `helper_step_${stepIndex}_remark`
      if (this.remarkLoading[key]) return
      
      const original = this.remarkOriginal[key]
      if (original == null) return

      // Restore original remark
      this.$set(this.helperList[stepIndex].lastTracking, 'remark', original)
      this.$delete(this.remarkTranslate, key)
      this.$set(this.remarkTranslated, key, false)
    },
    translateTrackingRemark(stepIndex, remark) {
      if (!remark) return
      const key = `tracking_step_${stepIndex}_remark`
      if (this.remarkLoading[key]) return
      
      this.$set(this.remarkLoading, key, true)
      const target = this.$i18n.locale

      TranslateRepository.translate({ text: remark, target })
        .then(response => {
          const translated = response?.data?.data?.translatedMessage || remark
          this.$set(this.remarkTranslate, key, translated)

          // Save original only once
          if (!(key in this.remarkOriginal)) {
            this.$set(this.remarkOriginal, key, remark)
          }

          // Update the remark in the messages list
          this.$set(this.messages[stepIndex], 'remark', translated)
          this.$set(this.remarkTranslated, key, true)
          this.$set(this.remarkLoading, key, false)
        })
        .catch(() => {
          this.$set(this.remarkLoading, key, false)
        })
    },
    revertTrackingRemark(stepIndex) {
      const key = `tracking_step_${stepIndex}_remark`
      if (this.remarkLoading[key]) return
      
      const original = this.remarkOriginal[key]
      if (original == null) return

      // Restore original remark
      this.$set(this.messages[stepIndex], 'remark', original)
      this.$delete(this.remarkTranslate, key)
      this.$set(this.remarkTranslated, key, false)
    },
    getProjectName(projectName) {
      if (typeof projectName === 'object') {
        return projectName?.[this.currentLocale] || projectName?.en || projectName?.zh || projectName?.km || projectName?.vi || '-'
      }
      return projectName || '-'
    },
    getTranslatedEnterpriseName(meta) {
      return meta?.translation?.enterpriseName?.[this.currentLocale] || meta?.translation?.enterpriseName?.en || meta?.translation?.enterpriseName?.zh || meta?.translation?.enterpriseName?.km || meta?.translation?.enterpriseName?.vi || meta?.enterpriseName || '-'
    },
    getTranslatedBuildingName(meta) {
      return meta?.translation?.buildingName?.[this.currentLocale] || meta?.translation?.buildingName?.en || meta?.translation?.buildingName?.zh || meta?.translation?.buildingName?.km || meta?.translation?.buildingName?.vi || meta?.buildingName || '-'
    },
    getTranslatedRoomName(meta) {
      return meta?.translation?.roomName?.[this.currentLocale] || meta?.translation?.roomName?.en || meta?.translation?.roomName?.zh || meta?.translation?.roomName?.km || meta?.translation?.roomName?.vi || meta?.roomName || '-'
    },
    onItemImageError(event) {
      const element = event && event.target
      const fallback = '/bottle-of-water.png'
      if (element && !element.src.includes(fallback)) {
        element.src = fallback
      }
    },
    getStepAssignOperatorId(step) {
      let assignOperatorId = step?.assignOperatorId

      if (typeof step?.assignedOperatorId === 'string') {
        assignOperatorId = step?.assignedOperatorId
      }

      if (typeof step?.assignOperator?.id === 'string') {
        assignOperatorId = step?.assignOperator?.id
      }

      return assignOperatorId
    },
    getStepAssignedByOperatorName(step) {
      return step?.assignedBy?.name
    },
    getStepAssignedByOperatorId(step) {
      return step?.assignedBy?.id
    },
    getDepartmentNames(departments) {
      // department.name can be object or string
      return departments.map(department => {
        if (typeof department.name === 'object') {
          return department.name?.[this.$i18n.locale.split('-')[0]]
            || department.name?.en
            || department.name?.vi
            || department.name?.km
            || department.name?.zh
            || this.$t('general.not_available')
        }
        return department.name
      }).join(', ')
    },
    replaceHelper(id) {
      this.$refs.replaceOperatorModal.show(this.activeChannel, id)
    },
    openOperatorTrackerModal(id, channel) {
      const name = [channel?.operator?.firstName, channel?.operator?.lastName].filter(Boolean).join(' ') || channel.assignedOperator || channel?.operator?.name
      this.$refs.operatorTrackerModal.show(id, this.activeChannel.id, name)
    },
    handleDeleteHelper(id) {
      let deleteTitle = this.$t('alert.sure_delete_operator')

      const isMarkCompleted = this.activeChannel.isMainOperatorCompleted
      && (this.activeChannel?.helperOperatorIds?.length === 1
      || (this.helperList?.length > 1 && this.helperList.filter(helper => helper.id !== id).every(helper => helper.status === 'completed')))

      if (isMarkCompleted) {
        deleteTitle += this.$t('alert.delete_operator_hint')
      }

      this.$bvModal
        .msgBoxConfirm(
          deleteTitle,
          {
            title: this.$t('alert.delete_operator'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: this.$t('button.confirm'),
            cancelTitle: this.$t('button.no'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(value => {
          if (value) {
            ServiceSystemRepository.deleteHelper(id).then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('general.deleted'),
                  icon: 'TrashIcon',
                  variant: 'success',
                  text: this.$t('general.helperDeleted'),
                },
              })
            })
          }
        })
    },
    getMediaNameOrUrl(media) {
      return media?.name || media?.url
    },
    copyToClipboard(text) {
      this.$copyText(text).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('general.copied'),
              icon: 'CopyIcon',
            },
          })
        },
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('general.cannotCopy'),
              icon: 'AlertCircleIcon',
            },
          })
        },
      )
    },
    getStatusDescription(status, operator, operatorId, newOperator, newOperatorId, currentStatus = null) {
      // Get the translation template
      let template = this.$t(`statusDescription.${status}`)

      if (status === 'pendingSystem') {
        template = this.$t(`statusDescription.pendingSystem`)
      }

      if (status === 'pendingHuman') {
        template = this.$t(`statusDescription.pendingHuman`)
      }

      let result = template.replace(
        '<strong>{operator1}</strong>',
        `<strong class="operator-link" onclick="window.routeToOperator('${operatorId || ''}')">${operator || ''}</strong>`,
      )

      result = result.replace(
        '<strong>{operator2}</strong>',
        `<strong class="operator-link" onclick="window.routeToOperator('${newOperatorId || ''}')">${newOperator || ''}</strong>`,
      )

      // First replace new operator placeholder
      result = result.replace(
        '<strong>{newOperator}</strong>',
        `<strong class="operator-link" onclick="window.routeToOperator('${newOperatorId || ''}')">${newOperator || ''}</strong>`,
      )

      // Then replace original operator placeholder
      result = result.replace(
        '<strong>{operator}</strong>',
        `<strong class="operator-link" onclick="window.routeToOperator('${operatorId || ''}')">${operator || ''}</strong>`,
      )

      if (status === 'deleted') {
        const statusText = this.$t(`status.${currentStatus}`)
        result = result.replace(
          '<strong>{status}</strong>',
          `<strong class="${currentStatus}">${statusText}</strong>`,
        )
      }

      return result
    },
    handleShowEmployeeDetailModal(id) {
      this.$refs.employeeDetailModal.show(id)
    },
    getOrigin(channel) {
      const origin = channel?.origin || 'external'
      const validOrigin = ['external', 'manual', 'chatagent']

      if (channel?.subOrigin) {
        if (channel?.createdByOperator?.name) {
          return `${this.$t(`general.${channel?.subOrigin} `)} / ${channel?.createdByOperator?.name}`
        }
        return this.$t(`general.${channel?.subOrigin}`)
      }

      if (validOrigin.includes(origin)) {
        return this.$t(`general.${origin}`)
      }

      return this.$t('general.not_available')
    },
    isValidValue(value, key) {
      if (key === 'addressInfo') {
        return false
      }
      if (key === 'files' && Array.isArray(value)) {
        return value.length > 0
      }
      if (key === 'scheduleType') {
        return value !== null && value !== undefined && value !== '' && value !== 0
      }
      if (key === 'addressType') {
        return value !== null && value !== undefined && value !== '' && value !== 0
      }
      if (key === 'subscriptionType') {
        return value !== null && value !== undefined && value !== '' && value !== 0
      }
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return value !== null && value !== undefined && value !== ''
    },
    getType(parameter) {
      return parameter?.type || 'text'
    },
    getDepartmentName(departmentName, operator) {
      if (!operator) {
        return this.$t('general.not_available')
      }

      if (typeof departmentName === 'string') {
        return departmentName || this.$t('general.not_available')
      }

      return (
          departmentName?.[this.$i18n.locale.split('-')[0]]
          || departmentName?.en
          || departmentName?.vi
          || departmentName?.km
          || departmentName?.zh
          || this.$t('general.not_available')
      )
    },
    getLabel(key) {
      // Prefer label from latest params group based on selected locale
      if (this.activeChannel?.origin !== 'chatagent') {
        const paramGroups = Array.isArray(this.activeChannel?.params) ? this.activeChannel.params : []
        const latestGroup = paramGroups.length > 0 ? paramGroups[paramGroups.length - 1] : null
        const parameters = Array.isArray(latestGroup?.parameters) ? latestGroup.parameters : null
        if (parameters) {
          const p = parameters.find(pr => pr?.key === key)
          const name = p?.name
          if (name) {
            if (typeof name === 'string') return name
            if (typeof name === 'object') {
              const loc = this.currentLocale
              return name[loc] || name.en || name.vi || name.km || name.zh || key
            }
          }
        }
      }

      const labels = {
        scheduleType: this.$t('general.scheduleType.title'),
        scheduleDate: this.$t('general.scheduleDate'),
        addressType: this.$t('general.addressType.title'),
        address: this.$t('general.address'),
        description: this.$t('general.description'),
        bottleSize: this.$t('general.bottleSize'),
        qty: this.$t('general.qty'),
        files: this.$t('general.files'),
        chargeType: this.$t('general.chargeType.title'),
        subscriptionType: this.$t('general.subscriptionType.title'),
        specialInstructions: this.$t('field.specialInstructions'),
        items: this.$t('general.orderItems'),
        total: this.$t('general.total'),
      }
      return labels[key] || key
    },
    formatValue(key, value) {
      // Define valid values for each type
      const validValues = {
        scheduleType: ['1', '2'],
        addressType: ['1', '2', '3'],
        subscriptionType: ['1', '2', '3'],
        chargeType: ['single'],
        bottleSize: ['1', '2', '3'], // Add your valid bottle sizes here
      }

      // Check if key exists in validValues and value is valid
      if (validValues[key] && validValues[key].includes(value.toString())) {
        switch (key) {
          case 'bottleSize':
            return this.$t(`general.size.${value}`)
          case 'scheduleType':
            return this.$t(`general.scheduleType.${value}`)
          case 'addressType':
            return this.$t(`general.addressType.${value}`)
          case 'subscriptionType':
            return this.$t(`general.subscriptionType.${value}`)
          case 'chargeType':
            return this.$t(`general.chargeType.${value}`)
          case 'address':
            return typeof value === 'object' ? value?.addressName : value
          default:
            return value
        }
      }

      // Return raw value if not in predefined options
      return value
    },
    getOriginalPrice() {
      if (!('servicePriceInit' in this.activeChannel)) return this.$t('general.not_available')
      return `${formatNumber(this.activeChannel.servicePriceInit)} ${this.activeChannel.servicePriceCurrency || ''}`
    },
    getPrice() {
      if (!('servicePrice' in this.activeChannel)) return this.$t('general.not_available')

      if (this.activeChannel.servicePriceType === 1) {
        return `${formatNumber(this.activeChannel.servicePriceInit || 0)} ${this.activeChannel.servicePriceCurrency || ''}`
      }

      let price = formatNumber(
        this.activeChannel.servicePrice || 0,
        this.activeChannel.servicePriceCurrency,
      )
      const min = formatNumber(
        this.activeChannel.servicePriceMin || 0,
        this.activeChannel.servicePriceCurrency,
      )
      const max = formatNumber(
        this.activeChannel.servicePriceMax || 0,
        this.activeChannel.servicePriceCurrency,
      )

      if (this.activeChannel.servicePrice === 0) {
        if (this.activeChannel.servicePriceType === 1) price = min
        else if (this.activeChannel.servicePriceType === 2) price = `${min} - ${max}`
        else price = this.$t('field.negotiation')
      }

      return `${price} ${
        price !== this.$t('field.negotiation')
          ? this.activeChannel.servicePriceCurrency
          : ''
      }`
    },
    isImageFile(url) {
      return isImage(url)
    },
    showImagePreview(url, logId) {
      this.fileList = this.messages
        .find(log => log.id === logId)
        ?.remarkMediaIds.map(media => media.url)
      const index = this.fileList.findIndex(u => u === url)

      if (index !== -1) {
        this.currentImageIndex = index
        this.isModalVisible = true
      }
    },
    showMediaPreview(url, files) {
      if (!files || !Array.isArray(files)) return

      const index = files.findIndex(file => file.url === url)
      if (index !== -1) {
        this.mediaList = files
        this.currentMediaIndex = index
        this.isMediaModalVisible = true
      }
    },
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex -= 1
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.fileList.length - 1) {
        this.currentImageIndex += 1
      }
    },
    resetModal() {
      this.currentImageIndex = 0
      this.fileList = []
    },
    getVisibleFiles(remarkMediaIds, isLimit = true) {
      const files = remarkMediaIds.map(media => ({
        url: media.url,
        name: media.fileName,
        mimeType: media.fileType,
      }))
      return isLimit ? (this.showAll ? files : files.slice(0, 5)) : files
    },
    currentImage() {
      const image = this.fileList[this.currentImageIndex]
      return (
        image || {
          file: { type: '', name: '' },
          preview: null,
        }
      )
    },
    mappedValue(param, parameter) {
      const result = param.responseParams[camelize(parameter.key)]
      return result || param.responseParams
    },
    confirmDelete(messageId) {
      this.$bvModal
        .msgBoxConfirm(this.$t('alert.deleteThisMessage'), {
          title: this.$t('alert.areYouSure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('button.delete'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteMessage(messageId)
          }
        })
    },
    deleteMessage(messageId) {
      ChatMessageRepository.delete(messageId)
        .then(() => {})
        .then(() => {
          this.isModalOpen = false
        })
    },
    transcribeMessage(messageId) {
      // Close the popover if it's already opened
      if (this.showTranscribe[messageId]) {
        this.$set(this.showTranscribe, messageId, false)
        return
      }

      // Set loading to true and show the popover
      this.$set(this.transcribeLoading, messageId, true)
      this.$set(this.showTranscribe, messageId, true)

      // Get the transcribe
      ChatMessageRepository.transcribe(messageId)
        .then(response => {
          this.$set(this.transcribeError, messageId, false)
          this.$set(this.transcribeLoading, messageId, false)
          this.$set(
            this.transcribeContent,
            messageId,
              response?.data?.data || this.$t('no_voice_detected'),
          )
        })
        .then(error => {
          this.$set(this.transcribeLoading, messageId, false)
          this.$set(this.transcribeError, messageId, true)
        })
    },
    systemTranslatedMessage(message) {
      return message?.chatSettings?.translatedMessage
    },
    systemDetectedLanguage(message) {
      return message?.chatSettings?.detectedLanguage
    },
    systemTranslatedLanguage(message) {
      return message?.chatSettings?.translatedLanguage
    },
    actionTransfer() {
      if (this.activeChannel?.transferredFrom) {
        return this.$t('action.transferringFrom')
      }
      return this.$t('action.transferringTo')
    },

    mapTransferMerchantName(createdAt) {
      if (this.activeChannel?.transferredFrom) {
        return this.activeChannel.transferredFromName || this.$t('general.not_available')
      }
      if (this.activeChannel?.transferred) {
        const transferring = this.activeChannel.transferred.find(
          e => e.startedAt <= createdAt && (!e.endedAt || createdAt <= e.endedAt),
        )
        if (transferring) {
          return transferring?.toName || 'NO NAME'
        }
      }
      return this.$t('general.not_available')
    },
    getCountryCode(language) {
      return this.localeCountries.find(
        e => e.language.toLowerCase() === language?.toLowerCase(),
      )?.flag
    },
    isTranslate() {
      return (
        this.activeChannel.isAutoTranslate
          || JSON.parse(localStorage.getItem('chatSettings')).isTranslationOn == 1
      )
    },
    getEmoji(target) {
      if (target == null) {
        return
      }
      const data = this.getCountryByLanguageCode(this.languageEn, target)
      return data?.emoji
    },
    createObjectURL(file) {
      return window.URL.createObjectURL(file)
    },
    openFile(url) {
      if (!url) return
      window.open(url, '_blank')
    },
    getFileName(message) {
      return message.mediaUrl || message.file?.name
    },
    viewImage(message) {
      const image = message?.mediaUrl
      if (image) {
        this.image = image
      }
    },
    retrySendMessage(index) {
      if (this.activeChannel.state == this.conversationStatus.open) {
        this.$emit('retry', index)
      }
    },
    onTranslate(index) {
      // this.$emit("translate", index);
      this.$set(this.loading, index, true)

      const message = this.messages[index]
      const target = this.$i18n.locale
      TranslateRepository.translate({ text: message.message, target })
        .then(response => {
          this.messages[index].translatedMessage = response?.data?.data?.translatedMessage
          this.messages[index].translatedLanguage = response?.data?.data?.translatedLanguage
          this.messages[index].detectedLanguage = response?.data?.data?.detectedLanguage
          this.chatBoxKey += 1
          this.$set(this.loading, index, false)
        })
        .catch(err => {
          this.$set(this.loading, index, false)
        })
    },
    getParamName(parameter) {
      if (typeof parameter?.name === 'object') {
        return this.getNameBasedOnLanguage(parameter.name)
      }
      if (parameter?.name) {
        return parameter.name
      }
      if (parameter?.key) {
        return parameter.key
      }
      return ''
    },
    getResponse(responseParam) {
      if (typeof responseParam === 'object' && 'en' in responseParam) {
        return responseParam?.[this.currentLocale] || responseParam?.en
      }
      if (Array.isArray(responseParam) && responseParam[0]?.mimeType) {
        return {
          type: 'files',
          files: responseParam,
        }
      }
      return responseParam
    },
    getNameBasedOnLanguage(name) {
      const locale = localStorage.getItem('locale') || 'en'
      return name?.[locale] || name?.zh || name?.en || name?.km || name?.vi || ''
    },
    handleEditOperator() {
      if (!this.canEditOperator) return
      this.$emit('edit-operator')
    },
    handleEditStatus() {
      if (!this.canEditStatus) return

      this.$emit('edit-status', this.modalTitle)
    },
    prevMedia() {
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex -= 1
      }
    },
    nextMedia() {
      if (this.currentMediaIndex < this.mediaList.length - 1) {
        this.currentMediaIndex += 1
      }
    },
    resetMediaModal() {
      this.currentMediaIndex = 0
      this.mediaList = []
    },
  },
  setup() {
    const appStore = useAppStore()

    return {
      getCountryByLanguageCode,
      languageEn,
      localeCountries,
      isImage,
      isVideo,
      isDoc,
      isCsv,
      isExcel,
      isPdf,
      isWord,
      isAudio,
      getFileExtDisplay,
      FormatDate,
      appStore,
    }
  },
}
</script>

<style>
  .helper-btn-groups {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    display: flex;
    gap: 0.5rem;
  }

  .chats .tab-content {
    height: 100%;
    overflow: auto;
  }

  .wave-voice {
    width: 100%;
    height: 100%;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  .voice-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0.5rem 1rem 0.5rem 0;
  }

  .custom-chat .chat-left .chat-group-content {
    display: flex;
    align-items: start;
    flex-direction: row-reverse;
    width: 100%;
    gap: 1rem;
  }

  .btn-voice-to-text {
    font-size: 12px;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .bs-popover-bottom > .arrow::after {
    border-bottom-color: #fdfdfd !important;
  }

  .popover .popover-body {
    border-radius: 0.358rem;
    border: none;
  }

  .transcribe-container {
    height: 50px;
    display: flex;
    align-items: center;
  }

  .transcribe-container button {
    min-width: 8rem;
    max-height: 2.25rem;
    display: flex;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
  }

  .transcribe-content {
    max-width: 40%;
    min-height: 50px;
    display: flex;
    align-items: center;
    margin: 0;
  }

  .capitalize-first {
    text-transform: lowercase;
    /* Ensure all text is lowercase */
  }

  .capitalize-first::first-letter {
    text-transform: uppercase;
    /* Capitalize the first letter */
  }
</style>

<style lang="scss" scoped>
  .meta-data-card.meta-group {
    background-color: #f8f8f8;
    border-radius: 0.5rem;

    .detail-group.detail-group {
      display: flex;
      margin-bottom: 1rem;

      &:last-child {
        margin-bottom: 0;
      }

      label {
        width: 160px;
        font-weight: 500;
        color: #6e6b7b;
        font-size: 0.9rem;
        margin-bottom: 0;
        flex-shrink: 0;
      }

      p {
        color: #5e5873;
      }
    }
  }

  .name-initiator {
    display: flex;
    align-items: center;

    img,
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 0.5rem;
    }
  }

  .handling-by {
    position: relative;
    background-color: white;
    padding: 1.5rem;
    border-radius: 0.5rem;

    .tracking-item {

      .step-card {

        background-color: #F7F7F7;
        border-radius: 0.5rem;
      }
    }
  }

  .chat-agent-detail {
    &.detail-group-tab {

      .detail-group {
        display: flex;
        margin-bottom: 1rem;

        &:last-child {
          margin-bottom: 0;
        }

        label {
          width: 200px;
          font-weight: 500;
          color: #6e6b7b;
          font-size: 0.9rem;
          margin-bottom: 0;
          flex-shrink: 0;
        }

        p {
          color: #5e5873;
        }
      }
    }

    .detail-group {
      .meta-data-card {
        border-radius: 0.5rem;
      }

      label {
        font-weight: 600;
        color: #6e6b7b;
        font-size: 0.9rem;
        margin-bottom: 0.25rem;
        flex-shrink: 0;
      }

      p {
        color: #5e5873;
      }
    }

    .step-list {
      position: relative;
    }

    .step-card {
      background-color: white;
      // border: 1px solid #dee2e6;
      border-radius: 8px;
      padding: 15px;
      // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      box-shadow: none;
      margin-bottom: 14px;
    }

    .step-connector {
      position: absolute;
      left: -25px;
      top: 30px;
      width: 2px;
      height: calc(100% + 20px);
      background-color: #dee2e6;
      z-index: 1;
    }

    .step-number {
      position: absolute;
      left: -40px;
      top: 8px;
      width: 30px;
      height: 30px;
      // background-color: #8d5185;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
      z-index: 2;
    }

    .badge {
      padding: 0.5rem 0.75rem;
      font-size: 0.9rem;
    }
  }

  .pending {
    color: #ffc107;
  }

  .assignPrice {
    color: #2196f3;
  }

  .bg-assignPrice {
    background-color: #2196f3;
  }

  .pendingDispatch {
    color: #f39c12; /* New color for pending dispatch */
  }

  .bg-pending {
    background-color: #ffc107;
  }

  .bg-pendingDispatch {
    background-color: #f39c12; /* New color for pending dispatch */
  }

  .processing {
    color: rgb(0, 123, 255);
  }

  .bg-processing {
    background-color: rgb(0, 123, 255);
  }

  .cancel {
    color: #c0392b;
  }

  .bg-cancel {
    background-color: #c0392b;
  }

  // .unresolved {
  //   color: #c0392b;
  // }

  // .bg-unresolved {
  //   background-color: #c0392b;
  // }

  .unresolved {
    color: #ff8c00;
    /* Dark Amber */
  }

  .bg-unresolved {
    background-color: #ff8c00;
    /* Matching background */
  }

  .hold {
    color: #8d5185;
  }

  .replaced {
    color: #ff8c00;
  }

  .bg-replaced {
    background-color: #ff8c00;
  }

  .bg-hold {
    background-color: #8d5185;
  }

  .completed {
    color: #27ae60;
  }

  .resolved {
    color: #7e7e7e;
  }

  .bg-completed {
    background-color: #27ae60;
  }

  .bg-assign {
    // make any color different from bg-*
    background-color: #97b834;
  }

  .bg-resolved {
    background-color: #7e7e7e;
  }

  .bg-handover {
    background-color: var(--primary);
  }

  .handover {
    color: var(--primary);
  }

  .rejected {
    color: #e74c3c;
  }

  .bg-rejected {
    background-color: #e74c3c;
  }

  .bg-accepted {
    background-color: #2ecc71;
  }

  .bg-pendingPrice {
    background-color: #f1c40f;
  }

  .accepted {
    color: #2ecc71;
  }

  .pendingPrice {
    color: #f1c40f;
  }

  .deleted {
    color: #e74c3c;
  }

  .bg-deleted {
    background-color: #e74c3c;
  }

  .btn-flat-primary {
    background-color: transparent;
    border: none;
    color: #8d5185;

    &:hover:not(.not-allowed) {
      background-color: rgba(115, 103, 240, 0.12);
    }

    &:focus {
      box-shadow: none;
    }

    &.not-allowed {
      opacity: 0.5;
      cursor: not-allowed;

      .feather-icon {
        color: #b9b9c3;
      }

      &:hover {
        background-color: transparent;
      }
    }
  }

  .preview-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }

  audio.preview-thumbnail {
    width: 200px;
    min-width: 200px;
    height: 32px;
    padding: 0;
  }

  .video-thumbnail,
  .audio-thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.05);
    color: #7367f0;
  }

  .video-thumbnail:hover,
  .audio-thumbnail:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .image-modal {
    max-width: 800px !important;
    width: 80vw !important;
  }

  .image-modal .modal-dialog {
    max-width: 800px !important;
    width: 80vw !important;
  }

  .image-modal .modal-content {
    width: 100% !important;
    height: 80vh !important;
  }

  .image-modal .modal-body {
    width: 100% !important;
    height: 80vh !important;
  }

  .modal-image-container {
    height: 80vh;
  }

  .preview-one.video-preview {
    width: 100%;
    height: 100%;
    max-height: 70vh;
    background: #000;
  }

  .preview-one.audio-preview {
    width: 80%;
    max-width: 500px;
    height: auto !important;
    min-height: 50px;
    margin: auto;
    padding: 20px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  .media-modal {
    max-width: 800px !important;
    width: 80vw !important;
  }

  .media-modal .modal-dialog {
    max-width: 800px !important;
    width: 80vw !important;
  }

  .media-modal .modal-content {
    width: 100% !important;
    height: 80vh !important;
  }

  .media-modal .modal-body {
    width: 100% !important;
    height: 80vh !important;
    padding: 0 !important;
  }

  .modal-media-container {
    position: relative;
    width: 100%;
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    padding: 20px;
  }

  .media-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 60px;
  }
</style>

<style scoped>
  .flex-center-vertically {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .file-item {
    border: 1px solid #eee;
    border-radius: 4px;
    margin-bottom: 8px;
    align-items: center;
    padding: 4px 8px;
  }

  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 8px;
    flex: 1;
  }

  .remove-button {
    background: none;
    border: none;
    padding: 2px;
    cursor: pointer;
    margin-left: 8px;
  }

  .upload-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .uploading {
    opacity: 0.7;
    pointer-events: none;
  }

  .file-preview {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    transition: transform 0.2s ease;
  }

  .file-preview:hover {
    transform: scale(1.05);
  }

  .file-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-modal {
    max-width: 600px !important;
    width: 40vw !important;
    margin: 1.75rem auto;
  }

  .modal-image-container {
    position: relative;
    width: 100%;
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    padding: 20px;
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 60px;
  }

  .preview-one {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    border-radius: 4px;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .nav-button:hover {
    background: rgba(255, 255, 255, 1);
    transform: translateY(-50%) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .prev-button {
    left: 10px;
  }

  .next-button {
    right: 10px;
  }

  .file-preview-fallback {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  .file-preview-fallback .file-name {
    margin-top: 1rem;
    font-size: 1.2rem;
    color: #6e6b7b;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .file-name:hover {
    color: #7367f0;
    text-decoration: underline;
  }

  .audio-preview {
    width: 80% !important;
    max-width: 500px;
    height: 50px !important;
    margin: auto;
  }

  .preview-one.audio-preview {
    object-fit: initial;
  }

  video.preview-one {
    background: #000;
  }
</style>

<style>
  .modal-img-content {
    padding: 0 !important;
    height: 50vh !important;
  }

  .image-modal {
    width: 400px !important;
  }

  .image-modal .modal-dialog {
    width: 400px !important;
    max-width: 400px !important;
    margin: 1.75rem auto !important;
  }

  .image-modal .modal-content {
    width: 400px !important;
    height: 50vh !important;
  }

  .image-modal .modal-body {
    width: 400px !important;
    padding: 0 !important;
    height: 50vh !important;
  }

  .service-detail .nav-tabs .nav-link {
    padding: 0.61rem 0;
    margin-right: 1.2rem;
  }

  .detail-title {
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    color: var(--primary);
  }

  .operator-link {
    cursor: pointer;
    color: var(--primary);
  }

  .btn-translate.btn-translate.btn:focus{
    outline: none;
    background-color: #f4f0f8;
    border-color: #f4f0f8;
  }

  .btn-translate.btn-translate.btn:active{
    background-color: #f4f0f8;
    border-color: #f4f0f8;
  }

  .detail-group .chat-agent-card {
    margin-bottom: 1.5rem;
  }

  .detail-group .chat-agent-card:last-child {
    margin-bottom: 0;
  }

  .italic {
    font-style: italic;
  }
</style>
